$(document).ready(function () {
  // initialiaze jquery datepicker on page load
  $("#datepicker").datepicker();
  // this colors are used when creating custom events
  const colors = ["#F9CEFE", "#8180F3", "#c9b177", "#d459d2", "#8ab5ed"];

  // toasteer
  toastr.options = {
    closeButton: true,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  // utitly functions
  // get random color
  function getRandomColor() {
    return colors[Math.floor(Math.random() * colors.length)];
  }

  
 if (window.innerWidth <= 768) {
   console.log('on mobile test')
  const gotodesktoptext = document.querySelector('.first-step-desktop-swatch');
  if (gotodesktoptext) {
    gotodesktoptext.classList.remove('hidden');
  }
}

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isIOS) {
    $('body').addClass('ios');
  }
  



  // generate unique id for events and profile
  function generateUniqueId() {
    return "xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // this is used in second step to show gray color on div when toggled off
  const defaultGray = "#C1C1C1";

  function hexToRgba(hex, alpha = 1) {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  function parsePrettyDate(prettyDateStr) {
  // Remove suffix like 'th', 'st', etc.
  const cleanDate = prettyDateStr.replace(/(\d+)(st|nd|rd|th)/, "$1");
  return new Date(cleanDate); // Will still work for "28 June 2025"
}


  // Function to format the date as "25th July 2025"
function formatDate(date) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  const d = new Date(date);

  // Get “25 July 2025” etc. as three parts
  const parts = d.toLocaleDateString("en-GB", options).split(" ");
  const day = parseInt(parts[0], 10);

  // Pick the right suffix
  const suffix =
    day % 100 >= 11 && day % 100 <= 13           // 11th, 12th, 13th
      ? "th"
      : ["st", "nd", "rd"][day % 10 - 1] || "th"; // 1st, 2nd, 3rd, the rest th

  parts[0] = `${day}${suffix}`;                  // Replace the day with day+suffix
  return parts.join(" ");                        // “25th July 2025”
}

 function getNextDate(month, day) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // midnight local
  let eventDate = new Date(today.getFullYear(), month - 1, day);

  if (eventDate < today) {
    eventDate = new Date(today.getFullYear() + 1, month - 1, day);
  }

  // Format to "yyyy-mm-dd" without UTC shift
  return eventDate.getFullYear() +
    "-" + String(eventDate.getMonth() + 1).padStart(2, "0") +
    "-" + String(eventDate.getDate()).padStart(2, "0");
}


  function getFathersDayNZ() {
    const today = new Date();
    let year = today.getFullYear();

    // First day of September
    let date = new Date(year, 8, 1); // 8 = September

    // Find first Sunday
    while (date.getDay() !== 0) {
      date.setDate(date.getDate() + 1);
    }

    // If the date has passed, compute for next year
    if (date < today) {
      year++;
      date = new Date(year, 8, 1);
      while (date.getDay() !== 0) {
        date.setDate(date.getDate() + 1);
      }
    }

    return date.toISOString().split("T")[0];
  }

  function getProfileImageWithColor() {
    const profileImagewithColor = [
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Strawberry_Sorbet.png?v=1747196352",
        color: "#be7269",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Lavender_Mist.png?v=1747196401",
        color: "#a798b7",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Soft_Teal.png?v=1747196447",
        color: "#96aeae",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Olive_Sand.png?v=1747196511",
        color: "#a8a788",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Tangerine_Dust.png?v=1747196511",
        color: "#d1a570",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Vanilla_Glow.png?v=1747196511",
        color: "#cdc5ae",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Sage_Haze.png?v=1747196511",
        color: "#b8b297",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Peach_Cream.png?v=1747196511",
        color: "#d1a166",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Orchid_Veil.png?v=1747196511",
        color: "#9795a7",
      },

      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Cool_Slate.png?v=1747196511",
        color: "#8d99a6",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Coral_Blush.png?v=1747196511",
        color: "#cb8472",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Melon_Pop.png?v=1747196511",
        color: "#c68162",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Violet_Dream.png?v=1747196511",
        color: "#a890b3",
      },
      {
        url: "https://cdn.shopify.com/s/files/1/0719/6934/1716/files/Mint_Cloud.png?v=1747196952",
        color: "#99b1a4",
      },
    ];

    const randomIndex = Math.floor(
      Math.random() * profileImagewithColor.length
    );
    return profileImagewithColor[randomIndex];
  }

  // to get gendera based svg ( it was on used earlier but now we use same svg)
  function getGenderSVG(gender) {
    if (gender === "female") {
      return `<svg width="57" height="68" viewBox="0 0 57 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M27.5 33C36.6127 33 44 25.6127 44 16.5C44 7.3873 36.6127 0 27.5 0C18.3874 0 11 7.3873 11 16.5C11 25.6127 18.3874 33 27.5 33ZM0.0604261 57.2307C22.1974 71.4782 34.448 71.6326 56.0604 57.2307C56.0604 52.7307 52.5602 42.7307 43.5604 40.2307C35.9284 38.1107 23.9816 39.2268 16.5624 39.9199C15.2326 40.0441 14.0484 40.1548 13.0604 40.2307C6.56026 40.7307 -0.739574 48.4306 0.0604261 57.2307Z" fill="white"/>
</svg>`;
    } else {
      return `<svg width="57" height="68" viewBox="0 0 57 68" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M27.5 33C36.6127 33 44 25.6127 44 16.5C44 7.3873 36.6127 0 27.5 0C18.3874 0 11 7.3873 11 16.5C11 25.6127 18.3874 33 27.5 33ZM0.0604261 57.2307C22.1974 71.4782 34.448 71.6326 56.0604 57.2307C56.0604 52.7307 52.5602 42.7307 43.5604 40.2307C35.9284 38.1107 23.9816 39.2268 16.5624 39.9199C15.2326 40.0441 14.0484 40.1548 13.0604 40.2307C6.56026 40.7307 -0.739574 48.4306 0.0604261 57.2307Z" fill="white"/>
</svg>`;
    }
  }

  const profileList = $(".profile-list");

  const event_to_select = [
    "Birthday",
    "Christmas",
    "New year",
    "Mother's Day",
    "Father's Day",
    "Custom",
  ];

  // events with specified color ,this will get render on event selection
  const new_event_to_select = [
    {
      name: "Birthday",
      colorcode: "#821CE4",
    },
    {
      name: "Anniversary",
      colorcode: "#04BAF8",
    },
    {
      name: "New Year",
      colorcode: "#F58D4D",
    },
    {
      name: "Mother's Day",
      colorcode: "#a0c4ff",
      date: "05/11/2025",
    },
    {
      name: "Father's Day",
      colorcode: "#a0c4ff",
      date: "05/11/2025",
    },
    {
      name: "Valentines Day",
      colorcode: "#a0c4ff",
      date: "02/14/2025",
    },
    {
      name: "Christmas",
      colorcode: "#a0c4ff",
      date: "12/25/2025",
    },
    {
      name: "Custom",
      colorcode: "#79CEFE",
    },
  ];

  // disable first step next button if all events has shop for today false
  function checkFirstStepNextButton() {
    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];

    const isAllShopForTodayFalse = profiles.every((profile) =>
      profile.events.every((ev) => !ev.event.shopfortoday)
    );
    if (profiles.length === 0) {
      $(".first-step-next-btn").attr("disabled", true);
    } else {
      $(".first-step-next-btn").attr("disabled", false);
    }
  }

  // first step script
  // first step script
  // first step script
  checkFirstStepNextButton();
  // render created profile for step first
  // render profiles get two argument
  // show_list and show_hide_index which is useful when events with div open and we  have to close when clicked outside

  function renderProfiles(show_list, show_hide_index) {
    profileList.html("");
    let profiles = JSON.parse(localStorage.getItem("profiles")) || [];

    profiles.forEach((profile, index) => {
      const isVisible = show_list && index === show_hide_index;
      const profileDiv = $(`
            <div class='profile-item' >
                <div class='profile-icon'>
                  <img src='${profile.profileImage}' alt='${profile.name}'/>
                     <button type='button' class='delete-profile-btn' data-index='${index}' >
                     
               <svg width="5" height="5" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.13709 0.91015C5.17621 0.872402 5.20742 0.827242 5.2289 0.777304C5.25038 0.727366 5.2617 0.67365 5.2622 0.619291C5.2627 0.564931 5.25236 0.511017 5.2318 0.460694C5.21124 0.410371 5.18086 0.364646 5.14244 0.326189C5.10402 0.287731 5.05833 0.257311 5.00802 0.236702C4.95772 0.216093 4.90381 0.20571 4.84945 0.206156C4.79509 0.206603 4.74137 0.217871 4.69141 0.239303C4.64145 0.260735 4.59626 0.291903 4.55848 0.330986L2.91761 1.97131L1.27728 0.330986C1.2398 0.290763 1.1946 0.258501 1.14438 0.236125C1.09416 0.213749 1.03995 0.201717 0.984981 0.200747C0.930011 0.199777 0.875408 0.20989 0.824431 0.23048C0.773453 0.251071 0.727146 0.281718 0.68827 0.320594C0.649394 0.35947 0.618747 0.405777 0.598156 0.456755C0.577565 0.507732 0.567453 0.562335 0.568423 0.617305C0.569393 0.672275 0.581425 0.726487 0.603801 0.776706C0.626177 0.826926 0.658439 0.872124 0.698662 0.909604L2.3379 2.55048L0.69757 4.1908C0.625254 4.26841 0.585884 4.37106 0.587756 4.47712C0.589627 4.58318 0.632593 4.68438 0.707602 4.75939C0.782612 4.8344 0.883807 4.87736 0.989869 4.87923C1.09593 4.8811 1.19858 4.84174 1.27619 4.76942L2.91761 3.12909L4.55793 4.76997C4.63554 4.84228 4.73819 4.88165 4.84425 4.87978C4.95031 4.87791 5.05151 4.83494 5.12652 4.75993C5.20153 4.68492 5.24449 4.58373 5.24636 4.47767C5.24823 4.3716 5.20887 4.26896 5.13655 4.19135L3.49732 2.55048L5.13709 0.91015Z" fill="black"/>
                </svg>

                </button>
                </div>
               
                <div class='select-events-wrapper'> 
                       <button class='select-dates-btn ${
                         isVisible ? "clicked" : ""
                       }' data-index='${index}'> <span class='btn-text'> ${
        profile.name
      } </span>
                       <span class='select-dates-chev'> 
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="
">
  <path d="M6 9L12 15L18 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" filter="url(#glow)"></path>
  <defs>
    <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="0" stdDeviation="1.5" flood-color="white" flood-opacity="0.6"></feDropShadow>
    </filter>
  </defs>
</svg>

                    </span>
                </button>
                <div class='date-options' style='display: ${
                  isVisible ? "block" : "none"
                };'>
                 <p class='select-dates-title'> SELECT DATES </p>
                    ${profile.new_event_to_select
                      ?.map((event, eventid) => {
                        const selectedEvent = profile.events.find(
                          (e) => e.event.name === event.name
                        );
                        const isSelected = !!selectedEvent;
                        const eventDate = selectedEvent
                          ? selectedEvent.event.date
                          : "";

                        return `
                        <div class='date-picker-container'>
                            <label class='date-picker-label ${
                              isSelected ? "selecteddate" : ""
                            }'  data-event-id ='${eventid}' data-label-index='${index}'>${
                          event.name
                        }</label>
                            <input type="text" class="date-input hidden " placeholder="Select date" data-event-name='${
                              event.name
                            }'  data-event-color ='${
                          event.colorcode
                        }'    data-event="${event.name
                          .replace(/"/g, "&quot;")
                          .replace(/'/g, "&#39;")}"  value=' ${
                          eventDate ? eventDate : ""
                        }' data-index='${index}'>
                            <span class="calendar-icon date-picker" data-event-color ='${
                              event.colorcode
                            }' data-calender-value=' ${
                          eventDate ? eventDate : ""
                        }' style="display: ${
                          isSelected ? "none" : "inline-block"
                        };">
                            <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                               <path d="M11.05 1.3H9.75V0.65C9.75 0.477609 9.68152 0.312279 9.55962 0.190381C9.43772 0.0684819 9.27239 0 9.1 0C8.92761 0 8.76228 0.0684819 8.64038 0.190381C8.51848 0.312279 8.45 0.477609 8.45 0.65V1.3H4.55V0.65C4.55 0.477609 4.48152 0.312279 4.35962 0.190381C4.23772 0.0684819 4.07239 0 3.9 0C3.72761 0 3.56228 0.0684819 3.44038 0.190381C3.31848 0.312279 3.25 0.477609 3.25 0.65V1.3H1.95C1.43283 1.3 0.936838 1.50545 0.571142 1.87114C0.205446 2.23684 0 2.73283 0 3.25V11.05C0 11.5672 0.205446 12.0632 0.571142 12.4289C0.936838 12.7946 1.43283 13 1.95 13H11.05C11.5672 13 12.0632 12.7946 12.4289 12.4289C12.7946 12.0632 13 11.5672 13 11.05V3.25C13 2.73283 12.7946 2.23684 12.4289 1.87114C12.0632 1.50545 11.5672 1.3 11.05 1.3ZM11.7 11.05C11.7 11.2224 11.6315 11.3877 11.5096 11.5096C11.3877 11.6315 11.2224 11.7 11.05 11.7H1.95C1.77761 11.7 1.61228 11.6315 1.49038 11.5096C1.36848 11.3877 1.3 11.2224 1.3 11.05V6.5H11.7V11.05ZM11.7 5.2H1.3V3.25C1.3 3.07761 1.36848 2.91228 1.49038 2.79038C1.61228 2.66848 1.77761 2.6 1.95 2.6H3.25V3.25C3.25 3.42239 3.31848 3.58772 3.44038 3.70962C3.56228 3.83152 3.72761 3.9 3.9 3.9C4.07239 3.9 4.23772 3.83152 4.35962 3.70962C4.48152 3.58772 4.55 3.42239 4.55 3.25V2.6H8.45V3.25C8.45 3.42239 8.51848 3.58772 8.64038 3.70962C8.76228 3.83152 8.92761 3.9 9.1 3.9C9.27239 3.9 9.43772 3.83152 9.55962 3.70962C9.68152 3.58772 9.75 3.42239 9.75 3.25V2.6H11.05C11.2224 2.6 11.3877 2.66848 11.5096 2.79038C11.6315 2.91228 11.7 3.07761 11.7 3.25V5.2Z" fill="#ACACAE"/>
                              </svg>
                            </span>
                            <span class='date-checkbox'    data-event-color ='${
                              event.colorcode
                            }'   data-event="${event.name
                          .replace(/"/g, "&quot;")
                          .replace(
                            /'/g,
                            "&#39;"
                          )}"   data-index='${index}'    style='display: ${
                          isSelected ? "inline-block" : "none"
                        };'>
                                <svg width='20' height='20' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
                                </svg>
                            </span>
                        </div>
                    `;
                      })
                      .join("")}
                </div>
                </div>
               
            </div>
        `);
      profileList.append(profileDiv);
    });
    
    function isoToLocalDate(iso) {
  // "2026-02-14" → new Date(2026, 1, 14) (local midnight)
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

$(".date-input").each(function () {
  let defaultDate = $(this).val().trim();
  const eventName = $(this).data("event-name")?.toLowerCase();

  if (!defaultDate && eventName) {
    const lower = eventName.toLowerCase();
    if (lower.includes("mother"))      defaultDate = getNextDate(5, 11);
    else if (lower.includes("valentine")) defaultDate = getNextDate(2, 14);
    else if (lower.includes("christmas")) defaultDate = getNextDate(12, 25);
    else if (lower.includes("father"))    defaultDate = getFathersDayNZ();
    else if (lower.includes("new"))       defaultDate = getNextDate(1, 1);
  }

  const eventDateLocal = defaultDate ? isoToLocalDate(defaultDate) : null;
  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  $(this)
    .data("event-default-date", defaultDate)
    .datepicker("destroy")
    .datepicker({
      dateFormat: "yy-mm-dd",
      defaultDate: defaultDate || null,
      minDate: 0,

      beforeShowDay: function (date) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffFromToday = Math.floor((date - today) / MS_PER_DAY);
  const diffFromEvent = eventDateLocal
    ? Math.floor((date - eventDateLocal) / MS_PER_DAY)
    : null;

  let className = "";
  let title = "";
  let selectable = true;

  const isToday = date.getTime() === today.getTime();
  if (isToday) {
    className += " today-date"; 
    title = "Today";
  }

  // // --- Event-based logic
  // if (diffFromEvent === 0 || diffFromEvent === 1 || diffFromEvent === 2) {
  //   className += " blocked-date";
  //   title = "Sorry, we cannot deliver immediately after the event date";
  //   selectable = false;
  // } else if (diffFromEvent === 3 || diffFromEvent === 4) {
  //   className += " restricted-date";
  //   title = "Fast turnaround after the event – some items may be unavailable";
  //   selectable = true;
  // }

  // --- Today-based logic
  if (diffFromToday === 0 || diffFromToday === 1 || diffFromToday === 2) {
    className += " blocked-date";
    title = "Sorry, we need two days to process and ship an order";
    selectable = false;
  } else if (diffFromToday === 3 || diffFromToday === 4) {
    className += " restricted-date";
    title = "Some items may not be available; we’ll contact you if so";
    selectable = true;
  }

  return [selectable, className.trim(), title];
},


      onChangeMonthYear() { setTimeout(enableTooltipsOnCalendar, 10); },
      beforeShow()        { setTimeout(enableTooltipsOnCalendar, 10); },
      onClose()           { $(".ui-tooltip").remove(); },
    });

  setTimeout(enableTooltipsOnCalendar, 10);
});




  }

  // Delegate events since elements are dynamically added
  $(document).on("click", ".date-picker-container ", function (e) {
    const $input = $(this).find(".date-input");
    $input.removeClass("hidden").focus();

    setTimeout(() => {
  // Create calendar popup div
  const calendardiv = document.createElement('div');
  calendardiv.classList.add('calendar-popup');
  calendardiv.style.backgroundColor = '#dee0df';
  calendardiv.style.position = 'relative';

  // Create close (cross) icon
  const calendardivcross = document.createElement('span');
  calendardivcross.classList.add('calendar-popup-cross');
  calendardivcross.innerText = '×';
  calendardivcross.style.position = 'absolute';
  calendardivcross.style.top = '5px';
  calendardivcross.style.right = '5px';
  calendardivcross.style.cursor = 'pointer';
  calendardivcross.style.fontWeight = 'bold';
  calendardivcross.style.fontSize = '12px';

  // Add click handler to remove the popup
  calendardivcross.onclick = () => {
    calendardiv.remove();
  };

  const calendardivtext = document.createElement('span');
  calendardivtext.classList.add('calendar-popup-text');
  calendardivtext.innerText = 'Orange dates indicate fast turn around times so some products may not be  available. If this is the case we will get in touch & suggest great substitute options';
  calendardivtext.style.color = 'orange';
  calendardivtext.style.display = 'block';
  calendardivtext.style.fontSize = '9px';
      calendardivtext.style.padding = '5px';
        calendardivtext.style.paddingRight = '5px';
                 calendardivtext.style.lineHeight = '1';

  calendardiv.appendChild(calendardivcross);
  calendardiv.appendChild(calendardivtext);

  const calendarUI = document.querySelector('.ui-datepicker');
  if (calendarUI) {
    calendarUI.appendChild(calendardiv);
  }
}, 30);

  });

  $(document).on("change", ".date-input", function (e) {
    const date = $(this).val().trim();
    const profileIndex = $(this).data("index");
    const eventName = $(this).data("event");
    const eventColor = $(this).attr("data-event-color");
    if (!date) return;
    // Get profiles from localStorage
    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    // Update event date
    const profile = profiles[profileIndex];
    const existingEvent = profile.events?.find(
      (e) => e.event.name == eventName
    );
    if (existingEvent) {
      existingEvent.event.date = date;
    } else {
      const event_unique_id = generateUniqueId();
      profile.events.push({
        event: {
          name: eventName,
          date: date,
          shopfortoday: true,
          eventColor: eventColor,
          event_unique_id,
        },
      });
    }
    $(".first-step-next-btn").attr("disabled", false);
    // Save back to localStorage
    localStorage.setItem("profiles", JSON.stringify(profiles));

    // Re-render UI
    // show list of event when rendering the ui again
    renderProfiles(true, profileIndex);
  });

  $(document).on("click", ".date-checkbox", function (e) {
    const $container = $(this).closest(".date-picker-container");
    const $input = $container.find(".date-input");
    const profileIndex = $input.data("index");
    const eventName = $input.data("event");
    // $input.removeClass("hidden").focus();

    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];

    const profile = profiles[profileIndex];
    if (profile && profile.events) {
      profile.events = profile.events.filter((e) => e.event.name !== eventName);
    }
    localStorage.setItem("profiles", JSON.stringify(profiles));
    // Re-render UI
    // show list of event when rendering the ui again
    renderProfiles(true, profileIndex);
  });

  // Attach click event for dynamically added CUSTOM EVENT  using event delegation step first
  $(document).on("click", ".date-picker-label", function (e) {
    const parent_wrapper = $(this).closest(".profile-item");
    let profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    // const parent_wrapper = $(this).parent('.profile-item')
    const text_label = $(this).text().trim();
    let label_index = $(this).data("label-index"); // Get the index value
    let event_index = $(this).data("event-id");

    let newText = $(this).val().trim() || "Custom";
    if (text_label === "Custom") {
      let index = $(this).data("index"); // Get the index value
      let input = $("<input>", {
        type: "text",
        class: "custom-input",
        value: e.target.textContent,
        "data-index": e.target.dataset.index,
      });

      // let container = $("<div>").append(calendarIcon, dateCheckbox);
      $(this).replaceWith(input);
      input.focus();

      // Handle blur or Enter keypress to convert back to label
      input.on("blur keypress", function (event) {
        if (event.type === "blur") {
          let newText = $(this).val().trim() || "Custom";
          const profile = profiles[label_index];
          if (profile && profile.new_event_to_select) {
            // Set the current index with user input
            const customColor = getRandomColor();
            profile.new_event_to_select[event_index].name = newText;
            profile.new_event_to_select[event_index].colorcode = customColor;

            // If next index doesn't exist, push a new custom placeholder
            if (event_index + 1 >= profile.new_event_to_select.length) {
              profile.new_event_to_select.push({
                name: "Custom",
                colorcode: customColor,
              });
            }

            localStorage.setItem("profiles", JSON.stringify(profiles));
            renderProfiles(true, label_index);
          }

          parent_wrapper
            .find(".custom-input")
            .closest(".date-picker-container")
            .remove();
          if (
            $(`.date-picker-container [data-event='${newText}']`).length === 0
          ) {
            let newContainer = $(`
                        <div class="date-picker-container" >
                            <label class="date-picker-label" data-event-id=${event_index}  data-label-index=${label_index}>${newText}</label>
                            <input type="text" class="date-input hidden" placeholder="Select date" data-event="${newText}" data-event-color ='#79CEFE' data-index="${label_index}">
                            <span class="calendar-icon date-picker" data-event-color ='#79CEFE'>
                                <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.05 1.3H9.75V0.65C9.75 0.477609 9.68152 0.312279 9.55962 0.190381C9.43772 0.0684819 9.27239 0 9.1 0C8.92761 0 8.76228 0.0684819 8.64038 0.190381C8.51848 0.312279 8.45 0.477609 8.45 0.65V1.3H4.55V0.65C4.55 0.477609 4.48152 0.312279 4.35962 0.190381C4.23772 0.0684819 4.07239 0 3.9 0C3.72761 0 3.56228 0.0684819 3.44038 0.190381C3.31848 0.312279 3.25 0.477609 3.25 0.65V1.3H1.95C1.43283 1.3 0.936838 1.50545 0.571142 1.87114C0.205446 2.23684 0 2.73283 0 3.25V11.05C0 11.5672 0.205446 12.0632 0.571142 12.4289C0.936838 12.7946 1.43283 13 1.95 13H11.05C11.5672 13 12.0632 12.7946 12.4289 12.4289C12.7946 12.0632 13 11.5672 13 11.05V3.25C13 2.73283 12.7946 2.23684 12.4289 1.87114C12.0632 1.50545 11.5672 1.3 11.05 1.3ZM11.7 11.05C11.7 11.2224 11.6315 11.3877 11.5096 11.5096C11.3877 11.6315 11.2224 11.7 11.05 11.7H1.95C1.77761 11.7 1.61228 11.6315 1.49038 11.5096C1.36848 11.3877 1.3 11.2224 1.3 11.05V6.5H11.7V11.05ZM11.7 5.2H1.3V3.25C1.3 3.07761 1.36848 2.91228 1.49038 2.79038C1.61228 2.66848 1.77761 2.6 1.95 2.6H3.25V3.25C3.25 3.42239 3.31848 3.58772 3.44038 3.70962C3.56228 3.83152 3.72761 3.9 3.9 3.9C4.07239 3.9 4.23772 3.83152 4.35962 3.70962C4.48152 3.58772 4.55 3.42239 4.55 3.25V2.6H8.45V3.25C8.45 3.42239 8.51848 3.58772 8.64038 3.70962C8.76228 3.83152 8.92761 3.9 9.1 3.9C9.27239 3.9 9.43772 3.83152 9.55962 3.70962C9.68152 3.58772 9.75 3.42239 9.75 3.25V2.6H11.05C11.2224 2.6 11.3877 2.66848 11.5096 2.79038C11.6315 2.91228 11.7 3.07761 11.7 3.25V5.2Z" fill="#ACACAE"></path>
                                </svg>
                            </span>
                            <span class='date-checkbox' data-event-color ='#79CEFE' data-event="${newText}" data-index="${label_index}" style="display: none;">
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                                </svg>
                            </span>
                        </div>
                    `);
            parent_wrapper.find(".date-options").append(newContainer);
          }
          let newContainer2 = $(`
            <div class="date-picker-container">
                <label class="date-picker-label" data-label-index='${
                  event_index + 1
                }'>Custom</label>
                 <input type="text" class="date-input hidden" placeholder="Select date" data-event="Custom" data-index="${
                   event_index + 1
                 }">
                            <span class="calendar-icon date-picker">
                                <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.05 1.3H9.75V0.65C9.75 0.477609 9.68152 0.312279 9.55962 0.190381C9.43772 0.0684819 9.27239 0 9.1 0C8.92761 0 8.76228 0.0684819 8.64038 0.190381C8.51848 0.312279 8.45 0.477609 8.45 0.65V1.3H4.55V0.65C4.55 0.477609 4.48152 0.312279 4.35962 0.190381C4.23772 0.0684819 4.07239 0 3.9 0C3.72761 0 3.56228 0.0684819 3.44038 0.190381C3.31848 0.312279 3.25 0.477609 3.25 0.65V1.3H1.95C1.43283 1.3 0.936838 1.50545 0.571142 1.87114C0.205446 2.23684 0 2.73283 0 3.25V11.05C0 11.5672 0.205446 12.0632 0.571142 12.4289C0.936838 12.7946 1.43283 13 1.95 13H11.05C11.5672 13 12.0632 12.7946 12.4289 12.4289C12.7946 12.0632 13 11.5672 13 11.05V3.25C13 2.73283 12.7946 2.23684 12.4289 1.87114C12.0632 1.50545 11.5672 1.3 11.05 1.3ZM11.7 11.05C11.7 11.2224 11.6315 11.3877 11.5096 11.5096C11.3877 11.6315 11.2224 11.7 11.05 11.7H1.95C1.77761 11.7 1.61228 11.6315 1.49038 11.5096C1.36848 11.3877 1.3 11.2224 1.3 11.05V6.5H11.7V11.05ZM11.7 5.2H1.3V3.25C1.3 3.07761 1.36848 2.91228 1.49038 2.79038C1.61228 2.66848 1.77761 2.6 1.95 2.6H3.25V3.25C3.25 3.42239 3.31848 3.58772 3.44038 3.70962C3.56228 3.83152 3.72761 3.9 3.9 3.9C4.07239 3.9 4.23772 3.83152 4.35962 3.70962C4.48152 3.58772 4.55 3.42239 4.55 3.25V2.6H8.45V3.25C8.45 3.42239 8.51848 3.58772 8.64038 3.70962C8.76228 3.83152 8.92761 3.9 9.1 3.9C9.27239 3.9 9.43772 3.83152 9.55962 3.70962C9.68152 3.58772 9.75 3.42239 9.75 3.25V2.6H11.05C11.2224 2.6 11.3877 2.66848 11.5096 2.79038C11.6315 2.91228 11.7 3.07761 11.7 3.25V5.2Z" fill="#ACACAE"></path>
                                </svg>
                            </span>
                            <span class="date-checkbox" data-event="Custom" data-index="${
                              event_index + 1
                            }" style="display: none;">
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path>
                                </svg>
                            </span>
                
            </div>
        `);
          parent_wrapper.find(".date-options").append(newContainer2);
          $(".date-input").each(function () {
            const defaultDate = $(this).val().trim();
            $(this).datepicker("destroy"); // Clear previous initialization
            $(this).datepicker({
              dateFormat: "yy-mm-dd",
              defaultDate: defaultDate || null,
              minDate: 0,
            });
          });
        }
      });
    }
  });

  $(document).on("click", function (e) {
    if (
      !$(e.target).closest(".select-events-wrapper").length &&
      !$(e.target).hasClass("date-picker-label") &&
      !$(e.target).closest(".ui-datepicker").length // prevent hiding when clicking calendar
    ) {
      $(".date-options").hide();
      $(".select-dates-btn").removeClass("clicked");
    }
  });

  $(document).on("click", ".select-dates-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const dateOptions = $(this).siblings(".date-options");
    const isShowing = dateOptions.is(":visible");

    // Hide all other date options
    $(".date-options").not(dateOptions).hide();
    $(".select-dates-btn").not(this).removeClass("clicked");

    // Toggle the class clicked for css purpose
    dateOptions.toggle(!isShowing);
    $(this).toggleClass("clicked", !isShowing);
  });

  // add profile form for step 1
  $(".add-profile-form-button").on("click", function (e) {
    e.preventDefault();
    const name = $("#profile_name").val();
    const gender = $("#genderSelect").val();
    if (!gender) {
      $(".profile-add-error-msg").text("Please add gender");
      return;
    }
    if (!name) {
      $(".profile-add-error-msg").text("Please add  name");
      return;
    }
    // const svg = getGenderSVG(gender);
    const profileImageColor = getProfileImageWithColor();

    const bgColor = getRandomColor();
    const unique_id = generateUniqueId();
    const newProfile = {
      name,
      gender,
      profileImage: profileImageColor.url,
      profileColor: profileImageColor.color,
      events: [],
      event_to_select,
      new_event_to_select,
      unique_id,
    };

    let profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    profiles.push(newProfile);
    localStorage.setItem("profiles", JSON.stringify(profiles));
    const profile_modal = $(".profile-modal");
    profile_modal.hide();
    renderProfiles(false);
    $("#profile_name").val("");
    $("#genderSelect").val("");
    checkFirstStepNextButton();
    // $("#add-profile-form")[0].reset();
  });

  $(document).on("click", ".delete-profile-btn", function () {
    let profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    const index = $(this).data("index");
    profiles.splice(index, 1);
    localStorage.setItem("profiles", JSON.stringify(profiles));
    renderProfiles(false);
    checkFirstStepNextButton();
  });

  renderProfiles(false);

  // first step profile add modal open
  $(".add-icon-profile").on("click", function (e) {
    e.preventDefault();
    const profile_modal = $(".profile-modal");
    profile_modal.show();
  });
  const modal = document.querySelector(".profile-modal");
  const closeButton = document.querySelector(".close");

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      modal.style.display = "none";
    });
  }

  $(".first-step-next-btn").click((e) => {
    e.preventDefault();
    showNextStepForm();
  });

  // first step script finish

  // second step script start
  // second step data rendering
  function showNextStepForm() {
    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    const areAllEventsEmpty = profiles.every(
      (profile) => !Array.isArray(profile.events) || profile.events.length === 0
    );
    if (areAllEventsEmpty) {
      toastr.info("Please select date of events before proceeding");
      return;
    }
    $(".step-second-progress").addClass("active");
    $(".step-first-progress").removeClass("active");
    $(".first-step-form").hide();
    $(".header_section_second").removeClass("hidden");
    $(".header_section_first").addClass("hidden");
    $(".second-step-form").show();
    $(".data_event_container").empty();

    const date_events_container = document.querySelector(
      ".data_event_container"
    );
    const Mainprofiles = JSON.parse(localStorage.getItem("profiles")) || [];

    Mainprofiles?.forEach((profile, index) => {
      if (profile.events.length > 0) {
        const selected_profile_div = $(`
      <div class='created_profile_datesevent'> 
      <div class='profile-icon'> 
      <img class='created_profile_datesevent_svg' src='${
        profile.profileImage
      }' alt = ${profile.name}/>
      </div>
        <div class='created_profile_datesevent_detail'> 
          <div class='created_profile_datesevent_name'>
            ${profile.name}
          </div>
          ${profile.events
            .map((event, id) => {
              const color = profile.profileColor || defaultGray;
              const isActive = event.event.shopfortoday == true;
              const uniqueClass = `slider-${index}-${id}`;
              const wrapperId = `wrapper-${index}-${id}`;

              const fullColor = hexToRgba(color, 1);
              const lightColor = hexToRgba(color, 0.4);
              const lowlightColor = hexToRgba(color, 0.2);

              const styleTag = `<style data-id="${wrapperId}">
            
                    #${wrapperId} .${uniqueClass}::before {
          background-color: ${isActive ? fullColor : "#000000"} !important;
        }
        #${wrapperId} input:checked + .${uniqueClass} {
          background-color: ${isActive ? fullColor : "#C1C1C1"} !important;
        }
            </style>`;

              $("head").append(styleTag);

              return `
              <div id="${wrapperId}" class='created_event-date-wrapper ${uniqueClass}' data-colorcode ='${
                profile.profileColor
              }' data-profile="${index}" data-event="${id}">
                <span class='created_event_name' >
                  ${event.event.name}
                </span>
                <span class='created_event_date' >
                  <input type="text" id="datepicker-${index}-${id}" class="shopfortoday-date-edit" data-event-name='${
                event.event.name
              }' disabled value="${formatDate(event.event.date)}"  />
                </span>
                
                <div class="edit-events-switch">
                  <span class='edit_created_events'>Edit</span>
                  <div class='shopfortoday_toggle_btn' data-color="${
                    profile.profileColor
                  }"> 
                    <label class="switch" for='${uniqueClass}'>
                      <input class='shopfortoday_checkbox' id='${uniqueClass}' type="checkbox" ${
                isActive ? "checked" : ""
              }>
                      
                      <span class="slider round ${uniqueClass}"></span>
                    </label>
                  </div>
                </div>
              </div>`;
            })
            .join("")}
        </div>
      </div>
    `);

        // Initialize the datepicker for all the date input fields
        selected_profile_div.find(".shopfortoday-date-edit").datepicker({
          dateFormat: "dd M yy",
          minDate: 0, // Use a different format for the datepicker
          onSelect: function (dateText) {
            // Update the event's date value when the user selects a new date
            const profileIndex = $(this)
              .closest(".created_event-date-wrapper")
              .data("profile");
            const eventIndex = $(this)
              .closest(".created_event-date-wrapper")
              .data("event");

            // Fetch the current profiles from localStorage
            let Mainprofiles =
              JSON.parse(localStorage.getItem("profiles")) || [];

            // Update the event's date in the profiles array
            if (
              Mainprofiles[profileIndex] &&
              Mainprofiles[profileIndex].events[eventIndex]
            ) {
              Mainprofiles[profileIndex].events[eventIndex].event.date =
                dateText;

              // Store the updated profiles back to localStorage
              localStorage.setItem("profiles", JSON.stringify(Mainprofiles));
            }

            // Update the date input field with the new formatted date
            $(this).val(formatDate(dateText));
          },
        });

        // Bind the "Edit" button click event to show the datepicker
        selected_profile_div.find(".edit_created_events").click((e) => {
          // Find the corresponding datepicker input for this event
          const datepickerInput = $(e.target)
            .closest(".created_event-date-wrapper")
            .find(".shopfortoday-date-edit");

          // Show the datepicker when "Edit" is clicked
          datepickerInput.show();
          setupDatepicker(datepickerInput);

          // Open the datepicker for the clicked event
          datepickerInput.datepicker("show");
              setTimeout(() => {
  // Create calendar popup div
  const calendardiv = document.createElement('div');
  calendardiv.classList.add('calendar-popup');
  calendardiv.style.backgroundColor = '#dee0df';
  calendardiv.style.position = 'relative';

  // Create close (cross) icon
  const calendardivcross = document.createElement('span');
  calendardivcross.classList.add('calendar-popup-cross');
  calendardivcross.innerText = '×';
  calendardivcross.style.position = 'absolute';
  calendardivcross.style.top = '5px';
  calendardivcross.style.right = '5px';
  calendardivcross.style.cursor = 'pointer';
  calendardivcross.style.fontWeight = 'bold';
  calendardivcross.style.fontSize = '12px';

  // Add click handler to remove the popup
  calendardivcross.onclick = () => {
    calendardiv.remove();
  };

  const calendardivtext = document.createElement('span');
  calendardivtext.classList.add('calendar-popup-text');
  calendardivtext.innerText = 'Orange dates indicate fast turn around times so some products may not be  available. If this is the case we will get in touch & suggest great substitute options';
  calendardivtext.style.color = 'orange';
  calendardivtext.style.display = 'block';
  calendardivtext.style.fontSize = '9px';
      calendardivtext.style.padding = '5px';
        calendardivtext.style.paddingRight = '5px';
                 calendardivtext.style.lineHeight = '1';

  calendardiv.appendChild(calendardivcross);
  calendardiv.appendChild(calendardivtext);

  const calendarUI = document.querySelector('.ui-datepicker');
  if (calendarUI) {
    calendarUI.appendChild(calendardiv);
  }
}, 30);
        });

        selected_profile_div
          .find(".created_profile_datesevent_svg")
          .html(profile.svg);
        selected_profile_div
          .find(".created_profile_datesevent_svg")
          .css("background-color", profile.bgColor);
        $(date_events_container).append(selected_profile_div);
      }
    });
    //window.history.replaceState(null, "", "#second-step");
  }

  $(".second-step-prev-btn").click((e) => {
    e.preventDefault();
    $(".first-step-form").show();
    $(".second-step-form").hide();
    currentStep = 1;
    $(".step-first-progress").addClass("active");
    $(".step-second-progress").removeClass("active");
    $(".header_section_second").addClass("hidden");
    $(".header_section_first").removeClass("hidden");
     window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
    
  });

  function enableTooltipsOnCalendar() {
    $(".ui-datepicker td[title]").tooltip({
      tooltipClass: "custom-datepicker-tooltip",
      track: true,
    });
  }

  function setupDatepicker(datepickerInput) {
  const today = new Date();
  const rawInputValue = datepickerInput.val().trim();
  const selectedDate = rawInputValue ? parsePrettyDate(rawInputValue) : null;
  const MS_PER_DAY = 1000 * 60 * 60 * 24;

  datepickerInput.datepicker("destroy").datepicker({
    dateFormat: "yy-mm-dd",
    minDate: 0,
    defaultDate: selectedDate,

    beforeShowDay: function (date) {
      const dayDiffToday = Math.floor((date - today) / MS_PER_DAY);
      let className = "";
      let title = "";
      let selectable = true;

      // //  Block 0–1 days from today
      if (dayDiffToday == 0 || dayDiffToday == 1) {
        className = "blocked-date";
        title = "Sorry, we need two days to process and ship an order";
        selectable = false;
      }

      // //  Restrict 2–3 days from today
      else if (dayDiffToday === 2 || dayDiffToday === 3) {
        className = "restricted-date";
        title =
          "Some items in your order may not be available as it is a quick turn around. We will email you if this is the case and suggest some similar options we can add to your order instead.";
        selectable = true;
      }

      //  Block 1–2 days after selected date
      // if (selectedDate) {
      //   const diffFromSelected = Math.floor((date - selectedDate) / MS_PER_DAY);
      //   if (diffFromSelected === 0 || diffFromSelected === 1 || diffFromSelected === 2) {
      //     className = "blocked-date";
      //     title = "Sorry, we cannot deliver immediately after the selected date";
      //     selectable = false;
      //   } else if (diffFromSelected === 3 || diffFromSelected === 4) {
      //     className = "restricted-date";
      //     title =
      //       "This date is quite close after your selected event – delivery may be limited.";
      //     selectable = true;
      //   }
      // }

      return [selectable, className, title];
    },

    onSelect: function (dateText) {
      const profileIndex = $(this)
        .closest(".created_event-date-wrapper")
        .data("profile");
      const eventIndex = $(this)
        .closest(".created_event-date-wrapper")
        .data("event");

      let Mainprofiles = JSON.parse(localStorage.getItem("profiles")) || [];

      if (
        Mainprofiles[profileIndex] &&
        Mainprofiles[profileIndex].events[eventIndex]
      ) {
        Mainprofiles[profileIndex].events[eventIndex].event.date = dateText;
        localStorage.setItem("profiles", JSON.stringify(Mainprofiles));
      }

      // Format and update input visually
      $(this).val(formatDate(dateText));
    },

    onChangeMonthYear: function () {
      setTimeout(enableTooltipsOnCalendar, 10);
    },
    beforeShow: function () {
      setTimeout(enableTooltipsOnCalendar, 10);
    },
    onClose: function () {
      $(".ui-tooltip").remove();
    },
  });

  setTimeout(enableTooltipsOnCalendar, 10);
}


  document.addEventListener("change", function (e) {
    if (e.target && e.target.classList.contains("shopfortoday_checkbox")) {
      const parentWrapper = e.target.closest(".created_event-date-wrapper");
      if (!parentWrapper) return;

      const profileIndex = parentWrapper.dataset.profile;
      const eventIndex = parentWrapper.dataset.event;
      const isChecked = e.target.checked;
      const Mainprofiles = JSON.parse(localStorage.getItem("profiles")) || [];
      const colorCode = parentWrapper.getAttribute("data-colorcode");

      if (Mainprofiles[profileIndex]?.events[eventIndex]) {
        const eventObj = Mainprofiles[profileIndex].events[eventIndex].event;

        let newColor = colorCode;

        if (isChecked) {
          eventObj.shopfortoday = true;
          eventObj.eventColor = newColor;
        } else {
          eventObj.shopfortoday = false;
          eventObj.eventColor = colorCode;
          newColor = defaultGray;
        }

        localStorage.setItem("profiles", JSON.stringify(Mainprofiles));

        const eventNameEl = parentWrapper.querySelector(".created_event_name");
        const sliderEl = parentWrapper.querySelector(".slider");
        const uniqueClass = sliderEl.classList[1];
        const wrapperId = `wrapper-${profileIndex}-${eventIndex}`;

        parentWrapper.id = wrapperId;

        const fullColor = hexToRgba(newColor, 1);
        const lightColor = hexToRgba(newColor, 0.4);
        const lowlightColor = hexToRgba(newColor, 0.2);

        $(`style[data-id="${wrapperId}"]`).remove();

        const styleTag = `<style data-id="${wrapperId}">
        #${wrapperId} .${uniqueClass}::before {
          background-color: ${isChecked ? fullColor : "#000000"} !important;
        }
        #${wrapperId} input:checked + .${uniqueClass} {
          background-color: ${isChecked ? fullColor : "#C1C1C1"} !important;
        }
        #${wrapperId} {
        }
      </style>`;

        $("head").append(styleTag);

        // eventNameEl.style.backgroundColor = fullColor;
        // parentWrapper.style.borderColor = fullColor;
      }
    }
  });

  // Navigation handlers
  $(".second-step-next-btn").click((e) => {
    e.preventDefault();
    currentProfileIndex = 0;
    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    const isAllShopForTodayFalse = profiles.every((profile) =>
      profile.events.every((ev) => !ev.event.shopfortoday)
    );
    if (isAllShopForTodayFalse) {
      toastr.info("Please enable shop for today for  events");
      return;
    }
    $(".third-step-form").show();
    currentStep = 3;
    $(".second-step-form").hide();
    showProfile(currentProfileIndex);
    $(".step-second-progress").removeClass("active");
    $(".header_section_third").removeClass("hidden");
    $(".header_section_second").addClass("hidden");
    $(".step-third-progress").addClass("active");
    //window.history.replaceState(null, "", "#third-step");
     window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  });

  $(".third-step-prev-btn").click((e) => {
    e.preventDefault();
    if (currentProfileIndex === 0) {
      $(".third-step-form").hide();
      $(".second-step-form").show();
      $(".step-second-progress").addClass("active");
      $(".step-third-progress").removeClass("active");
      $(".header_section_second").removeClass("hidden");
      $(".header_section_third").addClass("hidden");
    } else {
      currentProfileIndex--;
      showProfile(currentProfileIndex);
    }
    //window.history.replaceState(null, "", "#second-step");
     window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  });

  // $(".third-step-next-person").click((e) => {
  //   e.preventDefault();
  //   currentProfileIndex++;
  //   showProfile(currentProfileIndex);
  //    window.scrollTo({
  //   top: 0,
  //   behavior: 'smooth'
  // });
  // });

 // Store skipped profiles by unique_id in session

$(".third-step-next-person").click((e) => {
  e.preventDefault();

  const profiles       = JSON.parse(localStorage.getItem("profiles")) || [];
  const currentProfile = profiles[currentProfileIndex];
  const events         = currentProfile?.events || [];

  // ── 1. Gather every shop-for-today event that has no products ──────────────
  const incompleteEvents = events.filter(ev =>
    ev.event?.shopfortoday &&
    (!Array.isArray(ev.productSelected) || ev.productSelected.length === 0)
  );

  if (incompleteEvents.length) {
    // Build "Birthday, Christmas" style string
    const eventNames = incompleteEvents.map(ev => ev.event.name).join(", ");
    // Show toast **every** click until products are added
    toastr.info(`You're continuing without adding a product for: ${eventNames}.`);
    // ── If you still want to block the *first* time only, re-introduce the
    //    skipWarningOnceMap logic here before returning – otherwise let it flow.
  }

  // ── 2. Always move to the next profile (remove this return if you bring back a first-click block)
  currentProfileIndex++;
  showProfile(currentProfileIndex);

  window.scrollTo({ top: 0, behavior: "smooth" });
});





  let thirdStepClickCount = 0;
  function renderFourthStep() {
    const people = JSON.parse(localStorage.getItem("profiles")) || [];
    const Soonestresult = getSoonestShopForTodayEvent(people);
    const lastStepTotal = $(".last-step-total");
    lastStepTotal.text(
      `Todays Total: $${
        Soonestresult?.totalPrice ? Soonestresult?.totalPrice : "0"
      }`
    );
    const peopleList = document.querySelector(".fourth-step-people-container");
    const eventDetails = document.querySelector(".final-step-event-inner");
    peopleList.innerHTML = "";
    eventDetails.innerHTML = "";

    // Filter people who have at least one valid event
    const filteredPeople = people.filter((person, id) =>
      person.events.some(
        (eventObj) =>
          eventObj.event.shopfortoday &&
          Array.isArray(eventObj.productSelected) &&
          eventObj.productSelected.length > 0
      )
    );

    // Sort people by nearest event date
    filteredPeople.sort((a, b) => {
      const aMinDate = Math.min(
        ...a.events
          .filter((e) => e.event.shopfortoday && e.productSelected?.length > 0)
          .map((e) => new Date(e.event.date).getTime())
      );
      const bMinDate = Math.min(
        ...b.events
          .filter((e) => e.event.shopfortoday && e.productSelected?.length > 0)
          .map((e) => new Date(e.event.date).getTime())
      );
      return aMinDate - bMinDate;
    });

    // Render people list
    filteredPeople.forEach((person, id) => {
      const personDiv = document.createElement("div");
      personDiv.setAttribute("data-profile-id", person.unique_id);
      personDiv.className = "fourth-step-people-container-inner";

      const validEvents = person.events.filter(
        (eventObj) =>
          eventObj.event.shopfortoday == true &&
          Array.isArray(eventObj.productSelected) &&
          eventObj.productSelected.length > 0
      );
      personDiv.innerHTML = `
    <div class='shopfortoday-people-info-wrapper'> 
    <div class='shopfortoday-people-info'> 
    <div class='profile-icon' >
    <img src='${person.profileImage}' alt='profile'/>
    </div>
    <div class='final-step-person-detail detail'> 
      <h2 class="last-profile" style="color:${person.profileColor}">${
        person.name
      }</h2>
      <div style="margin-top: 5px;">
        ${validEvents
          .map(
            (event) =>
              `<div class='last-step-profile-event-wrapper people-event-wrapper'>
          <div class='shopfortoday_event'  style='background-color: ${person.profileColor}' >
          <span class='shopfortoday_event_name' > 
                    ${event.event.name}
                    
          </span>
        
          </div>
          </div>`
          )
          .join("")}
      </div>
             
     </div>
      </div>
      </div>
    `;

      // personDiv.addEventListener("click", () =>
      //   renderPersonDetails(person, id)
      // );
      peopleList.appendChild(personDiv);
    });

    // Render first valid person by default
    if (filteredPeople.length > 0) {
      filteredPeople.map((people)=>{
         renderPersonDetails(people);
      })
      $(".last-step-next-btn").attr("disabled", false);
    } else {
      eventDetails.innerHTML =
        "<p class='last-step-no-items' style='text-align:center'>No valid people or events to display.</p>";
      $(".last-step-next-btn").attr("disabled", true);
    }
  }

  function renderPersonDetails(person, idMain) {
    let renderPersonCurrentId;
    let renderPersoneventid;
 

    // Create the initial event div structure
    const eventDiv = document.createElement("div");
    eventDiv.classList.add("summery-content-wrapper");

     const eventProductDetail = document.createElement("div");
    eventProductDetail.classList.add("summary-product-contents");

    eventDiv.innerHTML = `
    <div class='profile-selected-wrapper'> 
    <div class='profile-icon'>
      <img src='${person.profileImage}' alt='profile-image'/>
      </div>
    </div>
    
  `;

    // Sort events by date (nearest first)
    const sortedEvents = person.events
      .filter(
        (eventObj) =>
          eventObj?.productSelected?.length > 0 && eventObj?.event.shopfortoday
      )
      .sort((a, b) => new Date(a.event.date) - new Date(b.event.date));
    // Now start the loop to append event-specific details

    sortedEvents.forEach((eventObj, i) => {
      if (
        eventObj?.productSelected?.length > 0 &&
        eventObj?.event.shopfortoday
      ) {
        const eventHTML = `
      <div class='last-step-profile-wrapper'>
      <div class='last-step-profile-title-address'>
            ${
              i === 0
                ? `<h2 class='profile-selected-title'>${person.name}</h2>`
                : ""
            }
          
            </div>


<div class='last-step-event-title-note'>
        <span class='last-step-evnet-title' style='background-color:${
          eventObj.event.eventColor
        }'>
          ${eventObj.event.name} 
    
        </span>
        <div class='giftnote-giftcard'>
        <div class='giftnote-giftwrap'>
        <span data-profile-id= '${person.unique_id}' data-event-id='${
          eventObj.event.event_unique_id
        }' class='last-step-gifnote-popup'> Gift Note </span>
        <span data-profile-id= '${person.unique_id}' data-event-id='${
          eventObj.event.event_unique_id
        }' class='last-step-giftwrap-popup'> Wrapping </span>
        </div>
        <span data-profile-id= '${person.unique_id}' data-event-id='${
          eventObj.event.event_unique_id
        }' class='last-step-giftcard-popup'> ADD A GIFT CARD</span>
        </div>
        </div>

          <div class='address-mobile-no'>
            <div class='profile-field address-field'> 
            <label class='profile-field-label'> Address </label>
            <input id="autocomplete" class='address-input'   placeholder="Enter an address or place" type="text" data-person-id =${
              person.unique_id
            }  data-event-id='${eventObj.event.event_unique_id}' value='${
          eventObj.event.address ? eventObj.event.address : ""
        }'>
            </div>
            <div class='profile-field phoneno-field'> 
            <label class='profile-field-label'> Mobile No. </label>
            <input data-profile-id = ${person.unique_id} data-event-id='${
          eventObj.event.event_unique_id
        }'  class='input-mobile-no' value='${
          eventObj?.mobile ? eventObj?.mobile : ""
        }' />
            </div>
            </div>
      
      </div>
    `;

        // Create product wrapper
        const productWrapper = document.createElement("div");
        productWrapper.className =
          "final-products-wrapper grid grid--1-col grid--2-col-tablet ";
        let totalPrice = 0;
        // Append each product
        eventObj.productSelected.forEach((product) => {
          totalPrice += product.price * product.quantity;
          const productHTML = `
        <div class='final-product-list selected-product grid__item'>
        <div class='seelcted-product-inner'  >
          <img class='selected-product-image' src="https:${product.image}" 
              alt="${product.name}">
          <span class='last-step-cross-icon' 
              data-profile-index="${person.unique_id}" 
              data-event-index="${eventObj.event.event_unique_id}" 
              data-product-index="${product.variantId}">
          </span>
          <div class='last-step-product-detail' style="margin-top: 10px;">
            <div class="last-step-inner-detail">${product.name}</div>
            ${
              product.type === "requestgift"
                ? `<span class='request-gift'>Pending</span>`
                : ""
            }
            <div class='last-step-price-quantity'> 
              <span class='last-step-prdt-qauntity'> - Qty ${
                product.quantity
              } - <span>$${product.price.toFixed(2)}</span></span>
            </div>
          </div>
        </div>
        </div>
      `;
          productWrapper.innerHTML += productHTML;
        });

        renderPersonCurrentId = person.unique_id;
        renderPersoneventid = eventObj.event.event_unique_id;
        const totalPriceHTML = document.createElement("div");
        totalPriceHTML.className =
          "event-total-price last-step-profile-wrapper";
        totalPriceHTML.setAttribute(
          "data-event-id",
          eventObj.event.event_unique_id
        );
        totalPriceHTML.setAttribute("data-profile-id", person.unique_id);
        const shippingCostRaw = eventObj.event.shipping_cost;
        const wrappingcostRaw = eventObj.event.wrapping_cost;
        const shippingCost =
          typeof shippingCostRaw === "number" && !isNaN(shippingCostRaw)
            ? shippingCostRaw
            : 0;
        const wrappingcost =
          typeof wrappingcostRaw === "number" && !isNaN(wrappingcostRaw)
            ? wrappingcostRaw
            : 0;
        const priceWithShippingCost = totalPrice + shippingCost;
        console.log("rpice wih shipping coset");
        totalPriceHTML.innerHTML = `Total: $${priceWithShippingCost.toFixed(
          2
        )}`;
        const shippingCostDetailDiv = generateShippingCostHTML(
          eventObj.event.event_unique_id,
          person.unique_id,
          eventObj.event.latitude
        );

        // Append event HTML and productWrapper
        eventProductDetail.innerHTML += eventHTML;
        eventProductDetail.appendChild(productWrapper);
        eventProductDetail.appendChild(shippingCostDetailDiv);
        eventProductDetail.appendChild(totalPriceHTML);
      }
    });
     const eventDetails = document.querySelector(".final-step-event-inner");
    console.log('event details',eventDetails)
    eventDiv.appendChild(eventProductDetail);
    eventDetails.append(eventDiv)

    updateTodaysTotal(renderPersonCurrentId, renderPersoneventid);

    // Append the populated eventDiv to the container
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest(".fourth-step-people-container-inner")) {
      const profiledetailwrapper = e.target.closest(
        ".fourth-step-people-container-inner"
      );
      const profiles = JSON.parse(localStorage.getItem("profiles")) || [];

      const profileId = profiledetailwrapper.getAttribute("data-profile-id"); // unique_id
      const profile = profiles.find((p) => p.unique_id == profileId);
      if (!profile) return;
      // renderPersonDetails(profile);
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target && e.target.classList.contains("last-step-cross-icon")) {
      e.preventDefault();
      const profileId = e.target.getAttribute("data-profile-index"); // unique_id
      const eventId = e.target.getAttribute("data-event-index"); // event_unique_id
      const variantId = e.target.getAttribute("data-product-index"); // variantId

      const profiles = JSON.parse(localStorage.getItem("profiles")) || [];

      const profile = profiles.find((p) => p.unique_id == profileId);
      if (!profile) return;

      const event = profile.events.find(
        (ev) => ev.event.event_unique_id == eventId
      );
      if (!event || !Array.isArray(event.productSelected)) return;
      // Find the index of the product that matches the variantId
      const productIndex = event.productSelected.findIndex(
        (product) => product.variantId == variantId
      );
      // If the product exists, remove it
      if (productIndex !== -1) {
        // Use splice to remove the product
        event.productSelected.splice(productIndex, 1);
        // Update profiles in localStorage
        const updatedProfiles = profiles.map((p) =>
          p.unique_id == profileId ? profile : p
        );

        localStorage.setItem("profiles", JSON.stringify(updatedProfiles));
        const profiles_updated =
          JSON.parse(localStorage.getItem("profiles")) || [];

        const lastStepTotal = $(".last-step-total");
        const Soonestresult = getSoonestShopForTodayEvent(profiles);
        lastStepTotal.text(
          `Todays Total: $${
            Soonestresult?.totalPrice ? Soonestresult?.totalPrice : "0"
          }`
        );
      }

      // Optionally, remove the product from the DOM
      const productElement = e.target.closest(".product-container");
      if (productElement) {
        productElement.remove();
      }

      renderFourthStep();
    }
  });

  // Call this when clicking the third step's next button
  function showFourthStep() {
    $(".fourth-step-form").show();
    renderFourthStep();
  }

  // $(".last-step-next-btn").click(async () => {
  //   $(".last-step-error-msg").text("");

  //   const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
  //   let firstInvalidInput = null;
  //   let hasInvalidInput = false;
  //   const allCartItems = [];

  //   // Step 1: Get all valid events with a date
  //   let allValidEvents = [];

  //   profiles.forEach((person) => {
  //     person.events.forEach((eventObj) => {
  //       if (
  //         eventObj.event.shopfortoday &&
  //         Array.isArray(eventObj.productSelected) &&
  //         eventObj.productSelected.length > 0 &&
  //         eventObj.event.date
  //       ) {
  //         allValidEvents.push({
  //           person,
  //           event: eventObj,
  //           eventDate: new Date(eventObj.event.date),
  //         });
  //       }
  //     });
  //   });

  //   if (allValidEvents.length === 0) {
  //     $(".last-step-error-msg").text("No valid events found.");
  //     $(".last-step-loader").addClass("hidden");
  //     return;
  //   }

  //   // Step 2: Find the nearest event
  //   allValidEvents.sort((a, b) => a.eventDate - b.eventDate);
  //   const nearest = allValidEvents[0];
  //   console.log("neared checking", nearest);

  //   const profile = nearest.person;
  //   const event = nearest.event;
  //   const profileId = profile.id || profile.profile_id || profile.profileId;
  //   const profileName = profile.name || "No profile";
  //   const eventId = event.event.id;
  //   const address = event.event.address || "";
  //   const mobile = event?.mobile || profile.mobile || "";
  //   const shippingcostregion = event.event.shipping_region_cost;
  //   const wrappingtype = event.event.wrapping;
  //   const shippingcost = event.event.shipping_cost;
  //   const wrappingcost = event.event.wrapping_cost;
  //   const $addressInput = $(
  //     `.address-input[data-person-id="${profileId}"][data-event-id="${eventId}"]`
  //   );
  //   const $mobileInput = $(
  //     `.input-mobile-no[data-profile-id="${profileId}"][data-event-id="${eventId}"]`
  //   );

  //   if (!address) {
  //     $addressInput.css("border", "1px solid red");
  //     hasInvalidInput = true;
  //     firstInvalidInput = $addressInput;
  //   } else {
  //     $addressInput.css("border", "");
  //   }

  //   if (!mobile) {
  //     $mobileInput.css("border", "1px solid red");
  //     hasInvalidInput = true;
  //     if (!firstInvalidInput) firstInvalidInput = $mobileInput;
  //   } else {
  //     $mobileInput.css("border", "");
  //   }

  //   if (hasInvalidInput && firstInvalidInput) {
  //     toastr.info(
  //       "Please fill the address and mobile number for the nearest event."
  //     );
  //     $("html, body").animate(
  //       {
  //         scrollTop: firstInvalidInput.offset().top - 100,
  //       },
  //       500
  //     );
  //     $(".last-step-error-msg").text(
  //       "Missing address or mobile number for the nearest event."
  //     );
  //     $(".last-step-loader").addClass("hidden");
  //     return;
  //   }

  //   // Step 3: Build cart items for the nearest event
  //   event.productSelected.forEach((product) => {
  //     if (product.variantId || product.variant_id) {
  //       allCartItems.push({
  //         id: parseInt(product.variantId || product.variant_id, 10),
  //         quantity: product.quantity || 1,
  //         properties: {
  //           _profile: profileName,
  //           _event: event.event.name || "No event",
  //           _date: event.event.date || "No date",
  //           _receiver_contact: mobile,
  //           _gift_note: event?.giftnote || profile.giftnote || "",
  //           _delivery_address: address,
  //           _shipping_region_cost: shippingcostregion,
  //           _wrappingtype: wrappingtype,
  //           _shippingcost: shippingcost,
  //           _wrappingcost: wrappingcost,
  //         },
  //       });
  //     }
  //   });

  //   if (allCartItems.length === 0) {
  //     $(".last-step-error-msg").text("No valid items to add to cart.");
  //     $(".last-step-loader").addClass("hidden");
  //     return;
  //   }

  //   // Step 4: Submit to Shopify
  //   try {
  //     const response = await fetch("/cart/add.js", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ items: allCartItems }),
  //     });

  //     if (response.ok) {
  //       // window.location.href = "/checkout";
  //     } else {
  //       $(".last-step-error-msg").text("Failed to add items to cart.");
  //       $(".last-step-loader").addClass("hidden");
  //     }
  //   } catch (err) {
  //     console.error("Error adding to cart:", err);
  //     $(".last-step-error-msg").text("Failed to add items to cart.");
  //     $(".last-step-loader").addClass("hidden");
  //   }
  // });

  $(".fourth-step-prev-btn").click((e) => {
    e.preventDefault();
    $(".third-step-form").show();
    showProfile(0);
    $(".fourth-step-form").hide();
    $(".step-third-progress").addClass("active");
    $(".step-four-progress").removeClass("active");
    $(".header_section_foruth").addClass("hidden");
    $(".header_section_third").removeClass("hidden");
     window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  });

  let currentEvnetuniqueId;
  let currentProfileUniqueId;
  let previouseuniqueId;
  let previouseEventuniqueId;

  let cartItemsToRender = [];
  function showProfile(index) {
    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    if (profiles) {
      cartItemsToRender = profiles;
      // renderCart();
    }

    $(".theripeople-delivery-address").val("");
    $(".theripeople-reciepentsnumber").val("");
    $(".theripeople-giftnote").val("");
    if (index >= profiles.length) {
      $(".third-step-form").hide();
      showFourthStep();
      $(".step-four-progress").addClass("active");
      $(".step-third-progress").removeClass("active");
      $(".header_section_foruth").removeClass("hidden");
      $(".header_section_third").addClass("hidden");

      return;
    }

    if (index === profiles.length - 1) {
      $(".third-step-next-person").text("Next");
    } else {
      $(".third-step-next-person").text("Next Person");
    }

    const profile = profiles[index];
    const currentprofile_unique_id = profile.unique_id;
    const filteredEvents = profile.events?.filter(
      (event) => event.event.shopfortoday
    );

    // If no shopfortoday events, move to the next profile
    if (filteredEvents.length === 0) {
      showProfile(index + 1);
      return;
    }
    $(".third-step-save-btn").attr("data-profile-id", currentprofile_unique_id);
    currentProfileIndex = index;
    $(".third-step-people-container").empty();

    const $profileHtml = $(`
    <div class="third-step-peps" data-thirdstepeps='${index}'>
    
      <div class="shopfortoday-item-people">
      <div class='shopfortoday-people-header'> 
       <h2 class="shopfortoday_profile-name" style ="color:${
         profile.profileColor
       }">${profile.name}</h2>
       <p style='color: ${
         profile.profileColor
       }'> Click the event you want to shop for</p>
       </div>
       <div class='shopfortoday-people-info'> 
       <div class='profile-icon'>
       <img src ='${profile.profileImage}' alt='${profile.name}'/>
       </div>
        <div class="detail">
         
          <div class="selected-products"></div>
          <div class='selected_productsevent_list'>
          ${filteredEvents
            .map((event, index) => {
              const productAvailable =
                event?.productSelected?.length > 0 || false;

              if (index === 0) {
                $(".third-step-save-btn").attr(
                  "data-event-unique-id",
                  event.event.event_unique_id
                );
                previouseEventuniqueId = event.event.event_unique_id;
                previouseuniqueId = profile.unique_id;
                currentEvnetuniqueId = event.event.event_unique_id;
                currentProfileUniqueId = profile.unique_id;
              }
              return `
            <div class="shopfortoday-event-date-wrapper people-event-wrapper ${
              index === 0 ? "active" : ""
            }" 
            data-event-unique_id =${event.event.event_unique_id}
            data-profile-unique_id = ${profile.unique_id}
           
                 data-event-index="${index}">
              <div class="shopfortoday_event"  style="background-color: ${
                index === 0 ? profile.profileColor : ""
              }" data-color-code = '${profile.profileColor}'   
              '>
              <span class="shopfortoday_event_name">  ${
                event.event.name
              } </span>
            
            
             
              </div>
            </div>
          `;
            })
            .join("")}
          </div>
        </div>
      </div>
      </div>
    </div>
  `);

    $(".third-step-people-container").append($profileHtml);
    updateSelectedProductsList(currentProfileUniqueId, currentEvnetuniqueId);
  }

  function updateSelectedProductsList(profileUniqueId, eventUniqueId) {
    console.log("updating product here");
    console.log("updated produc tlsit", profileUniqueId, eventUniqueId);
    localStorage.setItem("currenevent", eventUniqueId);
    localStorage.setItem("currentprofile", profileUniqueId);
    // Find the matching profile and event
    const cartItemsToRender = JSON.parse(
      localStorage.getItem("profiles") || "[]"
    );

    const profile = cartItemsToRender.find(
      (p) => p.unique_id == profileUniqueId
    );
    console.log("profiel on rendering on function", profile);
    const event = profile?.events?.find(
      (e) => e.event.event_unique_id == eventUniqueId
    );
    // Get stored products or empty array if none exist
    let productRender;
    productRender = event?.productSelected || [];

    // Create a merged list of products

    const product_selected_wrapper = document.querySelector(
      ".third-step-peopleselected-gift-list"
    );
    const $productsList = $(".selected-products");

    // Clear any existing content
    $productsList.empty();
    console.log("product to render", productRender);

    if (productRender.length === 0) {
      // Show "no products" message
      product_selected_wrapper.innerHTML =
        '<div class="no-products-selected">No products selected</div>';
    } else {
      // Clear wrapper and populate products list
      product_selected_wrapper.innerHTML = "";

      productRender.forEach((product) => {
        $productsList.append(`
        <div class="selected-product">
          <div class='seelcted-product-inner'> 
            <img class='selected-product-image' src="${product.image}" alt="${
          product.name
        }" />
            <div class='selected_product_quantity_wrapper'>
              <span class='selected-product-title'>${product.name} - $${(
          product.price * product.quantity
        ).toFixed(2)}</span>
${
  product.type === "requestgift"
    ? `<span class='request-gift'>Pending</span>`
    : ""
}
              <div class="slect-add-minus">
                <span class='selected_product_quantity_minus' 
                      data-profile-index="${profile.unique_id}" 
                      data-event-index="${event.event.event_unique_id}"
                      data-variant-id="${product.variantId}">-</span>
                <span class='selected_product_real_quantity' data-variant-id='${
                  product.variantId
                }' data-product-price='${product.price}'>${
          product.quantity
        }</span>
                <span class='selected_product_quantity_plus' 
                      data-profile-index="${profile.unique_id}" 
                      data-event-index="${event.event.event_unique_id}"
                      data-variant-id="${product.variantId}">+</span>
              </div>
            </div>
            <div class='selected_product_remove_icon' 
                data-profile-index="${profile.unique_id}" 
                 data-event-index="${event.event.event_unique_id}"
                 data-variant-id="${product.variantId}">
             <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_4023_2522)">
<ellipse cx="17.6417" cy="12.0527" rx="12.4415" ry="12.0527" fill="#F5F5F5"/>
<path d="M19.9161 10.6912C19.963 10.6459 20.0005 10.5917 20.0262 10.5318C20.052 10.4719 20.0656 10.4074 20.0662 10.3422C20.0668 10.2769 20.0544 10.2122 20.0297 10.1519C20.0051 10.0915 19.9686 10.0366 19.9225 9.99045C19.8764 9.9443 19.8216 9.9078 19.7612 9.88307C19.7008 9.85834 19.6361 9.84587 19.5709 9.84641C19.5057 9.84695 19.4412 9.86047 19.3813 9.88619C19.3213 9.91191 19.2671 9.94931 19.2217 9.99621L17.2527 11.9646L15.2843 9.99621C15.2393 9.94794 15.1851 9.90923 15.1248 9.88237C15.0646 9.85552 14.9995 9.84108 14.9335 9.83992C14.8676 9.83876 14.8021 9.85089 14.7409 9.8756C14.6797 9.90031 14.6241 9.93709 14.5775 9.98374C14.5308 10.0304 14.4941 10.086 14.4693 10.1471C14.4446 10.2083 14.4325 10.2738 14.4337 10.3398C14.4348 10.4058 14.4493 10.4708 14.4761 10.5311C14.503 10.5913 14.5417 10.6456 14.59 10.6905L16.557 12.6596L14.5886 14.628C14.5019 14.7211 14.4546 14.8443 14.4569 14.9716C14.4591 15.0988 14.5107 15.2203 14.6007 15.3103C14.6907 15.4003 14.8121 15.4519 14.9394 15.4541C15.0667 15.4563 15.1899 15.4091 15.283 15.3223L17.2527 13.3539L19.2211 15.323C19.3142 15.4098 19.4374 15.457 19.5647 15.4548C19.6919 15.4525 19.8134 15.401 19.9034 15.3109C19.9934 15.2209 20.045 15.0995 20.0472 14.9722C20.0494 14.8449 20.0022 14.7218 19.9154 14.6286L17.9483 12.6596L19.9161 10.6912Z" fill="black"/>
</g>
<defs>
<filter id="filter0_d_4023_2522" x="0.400195" y="0" width="34.4828" height="33.7055" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4.8"/>
<feGaussianBlur stdDeviation="2.4"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4023_2522"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4023_2522" result="shape"/>
</filter>
</defs>
</svg>
            </div>
          </div>
        </div>
      `);
      });
    }

    // Append the updated products list
    if (product_selected_wrapper) {
      product_selected_wrapper.appendChild($productsList[0]);
    }
    // Update any other UI elements as needed
    const result = calculatePrices(
      cartItemsToRender,
      profileUniqueId,
      eventUniqueId
    );
    showOverAllprice(
      result.profilePrice,
      result.overallPrice,
      profile?.name,
      result.eventPrice
    );
    $(".theripeople-delivery-address").val(profile?.deliveryAddress);
    $(".theripeople-giftnote").val(profile?.giftnote);
    $(".theripeople-reciepentsnumber").val(profile?.receiptNumber);
    updateTodaysTotal(profileUniqueId, eventUniqueId);
  }

  function showOverAllprice(PersonPrice, OverallPrice, PersonName, eventPrice) {
    $(".event-total").text(`Event Total: $${eventPrice}`);
    $(".total-total").text(` Overall Total $${OverallPrice}`);
  }

  function calculatePrices(
    profiles,
    profileUniqueId = null,
    eventUniqueId = null
  ) {
    let overallTotal = 0;
    let profileTotal = 0;
    let eventTotal = 0;

    let selectedProfile = null;

    if (profileUniqueId) {
      selectedProfile = profiles.find((p) => p.unique_id === profileUniqueId);
      if (!selectedProfile) {
        return { error: "Profile not found" };
      }
    }

    profiles.forEach((profile) => {
      profile.events.forEach((eventObj) => {
        if (eventObj.event.shopfortoday) {
          const event = eventObj.event;
          const products = eventObj.productSelected || [];

          // Total for all events and profiles
          overallTotal += products.reduce(
            (sum, product) => sum + product.price * (product.quantity || 1),
            0
          );

          // Total for matching eventUniqueId
          if (eventUniqueId && event.event_unique_id === eventUniqueId) {
            eventTotal += products.reduce(
              (sum, product) => sum + product.price * (product.quantity || 1),
              0
            );
          }

          // Total for matching profile only
          if (
            selectedProfile &&
            profile.unique_id === selectedProfile.unique_id
          ) {
            profileTotal += products.reduce(
              (sum, product) => sum + product.price * (product.quantity || 1),
              0
            );
          }
        }
      });
    });

    return {
      profilePrice: parseFloat(profileTotal.toFixed(2)),
      overallPrice: parseFloat(overallTotal.toFixed(2)),
      eventPrice: parseFloat(eventTotal.toFixed(2)),
    };
  }

  function removeProduct(uniqueId, eventUniqueId, variantId) {
    const cartItemsToRender = JSON.parse(
      localStorage.getItem("profiles") || "[]"
    );

    const profileIndex = cartItemsToRender.findIndex(
      (p) => p.unique_id === uniqueId
    );
    if (profileIndex === -1) return;

    const eventIndex = cartItemsToRender[profileIndex].events.findIndex(
      (e) => e.event.event_unique_id === eventUniqueId
    );
    if (eventIndex === -1) return;

    const event = cartItemsToRender[profileIndex].events[eventIndex];

    if (!event.productSelected) return;

    // Remove the product with matching variantId
    event.productSelected = event.productSelected.filter(
      (p) => p.variantId !== variantId
    );

    // If the productSelected array becomes empty, you can optionally delete it
    if (event?.productSelected?.length == 0) {
      delete event.productSelected;

      // 4. Find the event wrapper and make it gray
      const eventDiv = $(
        `.shopfortoday-event-date-wrapper[data-event-unique_id="${eventUniqueId}"][data-profile-unique_id="${uniqueId}"]`
      );
      const innerDiv = eventDiv.find(".shopfortoday_event");
      const colorCode = innerDiv.data("color-code");
      // Apply the background-color with !important
    }
    // Save the updated cartItems back to localStorage
    localStorage.setItem("profiles", JSON.stringify(cartItemsToRender));
    updateSelectedProductsList(uniqueId, eventUniqueId);
    updateTodaysTotal();
  }

  function updateQuantity(uniqueId, eventUniqueId, variantId, delta) {
    const cartItemsToRender = JSON.parse(
      localStorage.getItem("profiles") || "[]"
    );

    const profileIndex = cartItemsToRender.findIndex(
      (p) => p.unique_id === uniqueId
    );
    if (profileIndex === -1) return;

    const eventIndex = cartItemsToRender[profileIndex].events.findIndex(
      (e) => e.event.event_unique_id === eventUniqueId
    );
    if (eventIndex === -1) return;

    const products =
      cartItemsToRender[profileIndex].events[eventIndex].productSelected;
    if (!products) return;

    const productIndex = products.findIndex((p) => p.variantId === variantId);
    if (productIndex === -1) return;

    products[productIndex].quantity += delta;

    // If quantity drops to 0 or less, remove the product
    if (products[productIndex].quantity <= 0) {
      products.splice(productIndex, 1);
    }
    // Save the updated cartItems back to localStorage
    localStorage.setItem("profiles", JSON.stringify(cartItemsToRender));
    updateTodaysTotal();
    updateSelectedProductsList(uniqueId, eventUniqueId);
  }

  // Event handlers for quantity adjustments
  $(document).on(
    "click",
    ".selected_product_quantity_plus, .selected_product_quantity_minus, .selected_product_remove_icon",
    function () {
      const $target = $(this);
      const profileIndex = $target.data("profile-index");
      const eventIndex = $target.data("event-index");
      const variantId = $target.data("variant-id");

      if ($target.hasClass("selected_product_quantity_plus")) {
        updateQuantity(profileIndex, eventIndex, variantId, 1);
      } else if ($target.hasClass("selected_product_quantity_minus")) {
        updateQuantity(profileIndex, eventIndex, variantId, -1);
      } else if ($target.hasClass("selected_product_remove_icon")) {
        console.log("target hecking");
        removeProduct(profileIndex, eventIndex, variantId);
      }
    }
  );

  $(document).on("click touchstart", ".add-to-gift-list", function (e) {
  // Prevent duplicate event handling
  if (e.handled) return;
  e.handled = true;
  e.preventDefault();

  console.log("clicked add to gift list");

  const profiles = JSON.parse(localStorage.getItem("profiles") || "[]");
  const productContainer = $(this).closest(".product-block");

  const loader = $(this).find(".add-to-list-loader");
  const loaderbtn = $(this).find(".loader-btn");

  loader.removeClass("hidden");
  loaderbtn.removeClass("hidden");
  $(this).attr("disabled", true);

  // Get current IDs from global/local scope
  const productData = {
    image: productContainer.find("img").attr("src"),
    name: productContainer.find(".product-main-title").text().trim(),
    price: parseFloat(
      productContainer.find(".product-price").text().replace("$", "")
    ),
    variantId: $(this).data("variant-id"),
    quantity: 1,
    currentEvnetuniqueId,
    currentProfileUniqueId,
  };

  // Find the matching profile
  const profile = profiles.find(
    (p) => p.unique_id === currentProfileUniqueId
  );

  if (!profile) {
    loader.addClass("hidden");
    loaderbtn.addClass("hidden");
    $(this).attr("disabled", false);
    alert("Profile not found.");
    toastr.error("Something went wrong");
    return;
  }

  // Find the matching event
  const event = profile.events.find(
    (e) => e.event.event_unique_id === currentEvnetuniqueId
  );

  if (!event) {
    loader.addClass("hidden");
    loaderbtn.addClass("hidden");
    $(this).attr("disabled", false);
    alert("Event not found.");
    return;
  }

  // Ensure productSelected array exists
  if (!event.productSelected) {
    event.productSelected = [];
  }

  // Check if product already exists in selection
  const existingProduct = event.productSelected.find(
    (p) => p.variantId == productData.variantId
  );

  if (existingProduct) {
    existingProduct.quantity += productData.quantity;
  } else {
    event.productSelected.push(productData);
  }

  // Save updated data back to localStorage
  localStorage.setItem("profiles", JSON.stringify(profiles));

  // Update total & UI
  updateTodaysTotal(currentProfileUniqueId, currentEvnetuniqueId);
  updateSelectedProductsList(currentProfileUniqueId, currentEvnetuniqueId);
  toastr.info("Product Added Successfully");

  // Update today's total in final step UI
  const Soonestresult = getSoonestShopForTodayEvent(profiles);
  $(".last-step-total").text(
    `Todays Total: $${Soonestresult?.totalPrice || "0"}`
  );

  // Optional: UI background color highlight
  if (event.productSelected.length > 0) {
    const eventDiv = $(
      `.shopfortoday-event-date-wrapper[data-event-unique_id="${currentEvnetuniqueId}"][data-profile-unique_id="${currentProfileUniqueId}"]`
    );
    const innerDiv = eventDiv.find(".shopfortoday_event");
    const colorCode = innerDiv.data("color-code");
    // innerDiv.css("background-color", colorCode); // enable if needed
  }

  // Reset loader state
  setTimeout(() => {
    loaderbtn.addClass("hidden");
    loader.addClass("hidden");
    $(this).attr("disabled", false);
  }, 1500);
});


  function checkProductSelected(
    previousProfileid,
    previousEventid,
    cartItemsToRenderArr
  ) {
    const profile = cartItemsToRenderArr.find(
      (p) => p.unique_id === previousProfileid
    );

    if (!profile) {
      return;
    }

    // Find the event using the event_unique_id
    const event = profile.events.find(
      (e) => e.event.event_unique_id === previousEventid
    );
    const eventDiv = $(
      `.shopfortoday-event-date-wrapper[data-event-unique_id="${previousEventid}"][data-profile-unique_id="${previousProfileid}"]`
    );
    const innerDiv = eventDiv.find(".shopfortoday_event");
    const colorCode = innerDiv.data("color-code");
  }

  $(document).on("click", ".shopfortoday-event-date-wrapper", function () {
    const current_event_unique_id = $(this).attr("data-event-unique_id");
    const current_profile_unique_id = $(this).attr("data-profile-unique_id");
    currentEvnetuniqueId = current_event_unique_id;
    currentProfileUniqueId = current_profile_unique_id;
    cartItemsToRender = [];

    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    if (profiles) {
      cartItemsToRender = profiles;
    }
    checkProductSelected(
      previouseuniqueId,
      previouseEventuniqueId,
      cartItemsToRender
    );

    const profile = cartItemsToRender.find(
      (p) => p.unique_id === currentProfileUniqueId
    );

    if (!profile) {
      loader.addClass("hidden");
      alert("Profile not found.");
      return;
    }

    // Find the event using the event_unique_id
    const event = profile.events.find(
      (e) => e.event.event_unique_id === currentEvnetuniqueId
    );

    if (!event) {
      loader.addClass("hidden");
      alert("Event not found.");
      return;
    }
    const eventDiv = $(
      `.shopfortoday-event-date-wrapper[data-event-unique_id="${currentEvnetuniqueId}"][data-profile-unique_id="${currentProfileUniqueId}"]`
    );
    const innerDiv = eventDiv.find(".shopfortoday_event");
    const colorCode = innerDiv.data("color-code");

    // Update the local storage with the modified profiles array
    // localStorage.setItem('profiles', JSON.stringify(profiles));
    $(".shopfortoday-event-date-wrapper").removeClass("active");
    $(".shopfortoday_event").attr("style", `background-color: #ffffff80`);
    const savebtnthirdstep = $(".third-step-save-btn");

    savebtnthirdstep.attr("data-event-unique-id", current_event_unique_id);
    $(this).addClass("active");
    innerDiv.attr("style", `background-color: ${colorCode} ;`);
    activeEventIndex = parseInt($(this).data("event-index"), 10);
    // $(this).find(".shopfortoday_event_chevsvg").removeClass("hidden");
    // $(this).siblings().find(".shopfortoday_event_chevsvg").addClass("hidden");
    $(this).find(".shopfortoday_event_chevsvg").css("opacity", 1);
    $(this).siblings().find(".shopfortoday_event_chevsvg").css("opacity", 0);

    updateSelectedProductsList(
      current_profile_unique_id,
      current_event_unique_id
    );

    previouseEventuniqueId = currentEvnetuniqueId;
    previouseuniqueId = currentProfileUniqueId;
  });

  $(".third-step-save-btn").click(function (e) {
    e.preventDefault();

    // Use 'this' correctly in a normal function
    const data_profile_id = $(this).attr("data-profile-id");
    const data_event_id = $(this).attr("data-event-unique-id");
    const loader = $(this).find(".loader-save-btn");
    loader.removeClass("hidden");

    // Find the profile by its unique ID
    const profile = cartItemsToRender.find(
      (p) => p.unique_id == data_profile_id
    );

    if (!profile) {
      loader.addClass("hidden");
      alert("Profile not found.");
      return;
    }
    const event = profile.events.find(
      (e) => e.event.event_unique_id === data_event_id
    );

    if (!event) {
      loader.addClass("hidden");
      alert("Event not found.");
      return;
    }

    // Get values from form fields
    const deliveryAddress = $(".theripeople-delivery-address").val();
    const giftnote = $(".theripeople-giftnote").val();
    const receiptNumber = $(".theripeople-receiptentsnumber").val();

    // Update the profile
    profile.deliveryAddress = deliveryAddress;
    profile.giftnote = giftnote;
    profile.receiptNumber = receiptNumber;

    if (event.productSelected > 0) {
      const eventDiv = $(
        `.shopfortoday-event-date-wrapper[data-event-unique_id="${data_event_id}"][data-profile-unique_id="${data_profile_id}"]`
      );
      const innerDiv = eventDiv.find(".shopfortoday_event");
      const colorCode = innerDiv.data("color-code");

      // Apply the background-color with !important
      innerDiv.attr("style", `background-color: ${colorCode} !important;`);
    }
    // Save the updated profiles back to localStorage
    // localStorage.setItem("profiles", JSON.stringify(cartItemsToRender));
    updateTodaysTotal();
    $(this).text("Saved");
    setTimeout(() => {
      $(this).text("Save");
    }, 1000);
  });

  let currentStep = 0;
$(".step-header-main").click(function () {
    const targetStep = $(this).attr("data-step");
    let profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    if (profiles.length === 0) {
      toastr.info("Please add profile before proceeding");
      return;
    }

    const areAllEventsEmpty = profiles.every(
      (profile) => !Array.isArray(profile.events) || profile.events.length === 0
    );
    if (areAllEventsEmpty) {
      toastr.info("Please select date of events before proceeding");
      return;
    }

    const isAllShopForTodayFalse = profiles.every((profile) =>
      profile.events.every((ev) => !ev.event.shopfortoday)
    );
    if (isAllShopForTodayFalse) {
      if (targetStep == 3) {
        toastr.info("Please enable shop for today");
      } else if (targetStep == 1) {
        $(".form-step").hide();
        $(".header_section").addClass("hidden");
        $(".step-header-main").removeClass("active");
        $(this).addClass("active");
        $('.form-step[data-form-step="' + targetStep + '"]').show();
        $('.header_section[data-step="' + targetStep + '"]').removeClass(
          "hidden"
        );
      } else if (targetStep == 2) {
        showNextStepForm();
      } else {
        toastr.info("Please select dates for event");
      }

      return;
    }

    if (targetStep == 2) {
      showNextStepForm();
    }

    if (targetStep == 3) {
      showProfile(0);
    }

    console.log("targe step", targetStep);

    if (targetStep == 4) {
      showFourthStep();
      const step4 = document.querySelector(".step-four-progress");
      console.log("step 4", step4);
      if (step4) {
        step4.classList.add("active");
      }
    }

    // Continue only if profile check passed
    $(".form-step").hide();
    $(".header_section").addClass("hidden");
    $(".step-header-main").removeClass("active");
    $(this).addClass("active");

    $('.form-step[data-form-step="' + targetStep + '"]').show();
    $('.header_section[data-step="' + targetStep + '"]').removeClass("hidden");
  });



  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("last-step-gifnote-popup")) {
      const giftOverlay = document.querySelector(".product-details-overlay");
      giftOverlay.classList.add("giftnote-overlay");
      const dataProductId = e.target.getAttribute("data-profile-id");
      const eventuniqueId = e.target.getAttribute("data-event-id");
      const profiles = JSON.parse(localStorage.getItem("profiles") || "[]");
      const foundProfile = profiles.find(
        (profile) => profile.unique_id == dataProductId
      );
      const foundevent = foundProfile.events.find(
        (event) => event.event.event_unique_id == eventuniqueId
      );
      const giftNoteText = foundevent?.giftnote ? foundevent?.giftnote : "";
      document.body.classList.add("product-overlay");
      const giftnoteHtml = `
      <div class='product-overlay-inner'> 
        <button class='giftnote-close cross-icon-product-overlay' >
        <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_28_864)">
              <path d="M13.3208 20.7976C8.9108 20.7976 5.3208 17.2076 5.3208 12.7976C5.3208 8.38761 8.9108 4.79761 13.3208 4.79761C17.7308 4.79761 21.3208 8.38761 21.3208 12.7976C21.3208 17.2076 17.7308 20.7976 13.3208 20.7976ZM13.3208 2.79761C7.7908 2.79761 3.3208 7.26761 3.3208 12.7976C3.3208 18.3276 7.7908 22.7976 13.3208 22.7976C18.8508 22.7976 23.3208 18.3276 23.3208 12.7976C23.3208 7.26761 18.8508 2.79761 13.3208 2.79761ZM15.9108 8.79761L13.3208 11.3876L10.7308 8.79761L9.3208 10.2076L11.9108 12.7976L9.3208 15.3876L10.7308 16.7976L13.3208 14.2076L15.9108 16.7976L17.3208 15.3876L14.7308 12.7976L17.3208 10.2076L15.9108 8.79761Z" fill="black"></path>
            </g>
            <defs>
              <clipPath id="clip0_28_864">
                <rect width="26.2729" height="26.2729" fill="white" transform="translate(0.727051 0.797607)"></rect>
              </clipPath>
            </defs>
          </svg>
        </button>
        <div class='field'> 
          <textarea id='giftnote' class='field__input' data-profile-id='${dataProductId}' data-event-id ='${eventuniqueId}' placeholder='Gift Note' >${giftNoteText}</textarea>
          <label for='giftnote' class='field__label'>Gift Note</label>
        </div>
        <button id='saveGiftnote' class='button next-btn' >Save</button>
      </div>
    `;

      giftOverlay.innerHTML = giftnoteHtml;
      giftOverlay.style.display = "block"; // ensure it's visible

      // Handle Save
      const saveButton = giftOverlay.querySelector("#saveGiftnote");
      saveButton.addEventListener("click", function () {
        const textarea = giftOverlay.querySelector("#giftnote");
        const updatedNote = textarea.value;
        const profileId = textarea.getAttribute("data-profile-id");
        const eventId = textarea.getAttribute("data-event-id");

        const updatedProfiles = profiles.map((profile) => {
          if (profile.unique_id == profileId) {
            // Add/update giftnote at profile level
            let updatedProfile = { ...profile, giftnote: updatedNote };

            // Optional: Add/update giftnote inside the specific event
            if (updatedProfile.events) {
              updatedProfile.events = updatedProfile.events.map((eventObj) => {
                if (eventObj.event.event_unique_id == eventId) {
                  return {
                    ...eventObj,
                    giftnote: updatedNote,
                  };
                }
                return eventObj;
              });
            }

            return updatedProfile;
          }
          return profile;
        });

        localStorage.setItem("profiles", JSON.stringify(updatedProfiles));
        updateTodaysTotal();
        toastr.success("Gift note saved!");
      });

      // Handle Close (X)
      const closeButton = giftOverlay.querySelector(".giftnote-close");
      closeButton.addEventListener("click", function () {
        document.body.classList.remove("product-overlay");
        giftOverlay.classList.remove("giftnote-overlay");
        giftOverlay.style.display = "none";
      });
    }
  });

  document.addEventListener("input", function (e) {
    if (e.target.classList.contains("input-mobile-no")) {
      const input = e.target;
      const profileId = input.getAttribute("data-profile-id");
      const eventId = input.getAttribute("data-event-id");
      const newMobileNumber = input.value;

      const profiles = JSON.parse(localStorage.getItem("profiles") || "[]");

      const updatedProfiles = profiles.map((profile) => {
        if (profile.unique_id === profileId) {
          // Update mobile on the profile level
          const updatedProfile = { ...profile, mobile: newMobileNumber };

          // Update mobile inside the matching event if events exist
          if (Array.isArray(updatedProfile.events)) {
            updatedProfile.events = updatedProfile.events.map((event) => {
              if (event.event.event_unique_id == eventId) {
                return { ...event, mobile: newMobileNumber };
              }
              return event;
            });
          }

          return updatedProfile;
        }
        return profile;
      });

      localStorage.setItem("profiles", JSON.stringify(updatedProfiles));
    }
  });

  function getSoonestShopForTodayEvent(data) {
    const todayShopEvents = [];

    data.forEach((profile) => {
      profile.events?.forEach((eventWrapper) => {
        const { event, productSelected } = eventWrapper;
        if (
          event.shopfortoday &&
          productSelected &&
          productSelected.length > 0
        ) {
          todayShopEvents.push({
            profileName: profile.name,
            profileId: profile.unique_id,
            eventName: event.name,
            eventDate: new Date(event.date),
            eventId: event.event_unique_id,
            products: productSelected,
            shippingcost: event.shipping_cost,
          });
        }
      });
    });

    if (todayShopEvents.length === 0) return null;

    // Sort by nearest date
    todayShopEvents.sort((a, b) => a.eventDate - b.eventDate);

    const soonest = todayShopEvents[0];

    // Calculate total price
    const totalPrice = soonest.products.reduce((sum, prod) => {
      return sum + prod.price * (prod.quantity || 1);
    }, 0);

    const finalpricewithshippingcost = totalPrice + soonest.shippingcost;

    return {
      profileName: soonest.profileName,
      eventName: soonest.eventName,
      eventDate: soonest.eventDate.toISOString().split("T")[0],
      shopForToday: true,
      totalPrice: parseFloat(finalpricewithshippingcost),
      products: soonest.products.map((p) => p.name),
    };
  }

  function generateShippingCostHTML(eventId, personId, latitude = null) {
    const shippingDiv = document.createElement("div");
    shippingDiv.className = "event-shipping-cost";
    shippingDiv.setAttribute("data-event-id", eventId);
    shippingDiv.setAttribute("data-profile-id", personId);

    let cost = null;

    if (latitude !== null) {
      const isSouthIsland = latitude < -41.5;
      const isNorthIsland = latitude >= -41.5;
      cost = isSouthIsland ? 25 : isNorthIsland ? 15 : null;
      const island = isSouthIsland ? "South" : "North";

      if (cost !== null) {
        shippingDiv.innerHTML = `
        <strong>Shipping Cost:</strong> $${cost} <br/>
        <small>This cost saves you fuel or multiple shipping costs.</small>
      `;
      }
    }

    return shippingDiv;
  }

  function updateAddressInLocalStorage(input, address, latitude = null) {
    const personId = input.dataset.personId;
    const eventId = input.dataset.eventId;
    const allPeopleData = JSON.parse(localStorage.getItem("profiles") || "[]");

    const person = allPeopleData.find((p) => p.unique_id === personId);
    if (person) {
      const eventObj = person.events.find(
        (e) => e.event.event_unique_id === eventId
      );
      if (eventObj) {
        // Update address and coordinates
        eventObj.event.address = address;
        eventObj.event.latitude = latitude;

        // Determine shipping cost
        let shippingRegion = null;
        let shippingCost = null;
        let shippingRegionCostString = "";

        if (latitude !== null) {
          const isSouthIsland = latitude < -41.5;
          const isNorthIsland = latitude >= -41.5;

          shippingRegion = isSouthIsland
            ? "South"
            : isNorthIsland
            ? "North"
            : null;
          shippingCost = isSouthIsland ? 25 : isNorthIsland ? 15 : null;
          console.log("shipping reghyin checking", shippingRegion);

          if (shippingRegion) {
            shippingRegionCostString = `${shippingRegion}-$${shippingCost}`;
            eventObj.event.shipping_region_cost = shippingRegionCostString;
            eventObj.event.shipping_cost = shippingCost;
          }
        } else {
          eventObj.event.shipping_region_cost = "";
          eventObj.event.shipping_cost = "";
        }

        // Save updated profile
        localStorage.setItem("profiles", JSON.stringify(allPeopleData));

        // Update total price
        updateTodaysTotal(personId, eventId);

        // Update shipping cost UI
        const shippingDiv = document.querySelector(
          `.event-shipping-cost[data-event-id="${eventId}"][data-profile-id="${personId}"]`
        );
        if (shippingDiv) {
          if (shippingRegion && shippingCost !== null) {
            shippingDiv.innerHTML = `
            <strong>Shipping Cost:</strong> $${shippingCost} <br/>
            <small>This cost saves you fuel or multiple shipping costs.</small>
          `;
          } else {
            shippingDiv.innerHTML = "";
          }
        }
      }
    }
  }

  // Manual input save (blur or change)
  function handleManualInput(e) {
    console.log("handle manual input");
    if (e.target.classList.contains("address-input")) {
      const manuallyTypedAddress = e.target.value.trim();
      console.log("maually input", manuallyTypedAddress);
      updateAddressInLocalStorage(e.target, manuallyTypedAddress);
    }
  }

  document.addEventListener("change", handleManualInput);
  document.addEventListener("blur", handleManualInput, true);

  // Setup Google Autocomplete
  function applyGoogleAutocompleteToInputs() {
    const inputs = document.querySelectorAll(".address-input");

    inputs.forEach((input) => {
      const autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: "nz" },
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const selectedAddress = place.formatted_address || input.value;
        const location = place.geometry?.location;
        const latitude = location?.lat();

        updateAddressInLocalStorage(input, selectedAddress, latitude);
      });
    });
  }

  // Dynamic click handler for newly created inputs
  document.addEventListener("click", function (e) {
    const input = e.target.closest(".address-input");
    if (input) {
      const autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: "nz" },
      });

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const selectedAddress = place.formatted_address || input.value;
        const location = place.geometry?.location;
        const latitude = location?.lat();

        updateAddressInLocalStorage(input, selectedAddress, latitude);
      });
    }
  });

  // Run on page load and again after dynamic input added
  applyGoogleAutocompleteToInputs();
  addDeleteEventHandler();

  function addDeleteEventHandler() {
    document.addEventListener("click", function (e) {
      if (e.target.classList.contains("delete-event")) {
        const eventId = e.target.dataset.eventId;
        const wrapper = document.querySelector(`[data-event-id="${eventId}"]`);
        const allPeopleData = JSON.parse(
          localStorage.getItem("profiles") || "[]"
        );
        // Remove event from data
        allPeopleData.forEach((person) => {
          person.events = person.events.filter(
            (ev) => ev.event.event_unique_id !== eventId
          );
        });

        // Remove from DOM
        if (wrapper) wrapper.remove();
      }
    });
  }

  // Create HTML from product data
  function generateProductHTML(products) {
    return products
      .map(
        (product) => `
      <div class="grid__item product_grid_item product_grid_item_product  product-block" data-collection-id='{{ section.settings.fourthstep_collection.id }}' data-product-id="${
        product.id
      }">
        <div class="card-wrapper-item">
          <div class='grid-item-image'>
            <img src="${product.image || ""}" alt="${
          product.title
        }" class="grid-image grid-image-product" loading="lazy">
            
              ${
                product.available
                  ? `<span data-variant-id='${product.variantId}' class='add-to-gift-list'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-shopping-cart">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M17 17h-11v-14h-2" />
                      <path d="M6 5l14 1l-1 7h-13" />
                    </svg>
                    <span class='loader-btn hidden '>
                    </span>
                  </span>`
                  : `<span data-variant-id='${product.variantId}' class='add-to-gift-list soldout'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-shopping-cart">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M17 17h-11v-14h-2" />
                      <path d="M6 5l14 1l-1 7h-13" />
                    </svg>
                  </span>`
              }
          </div>
          <div class="card-information">
            <div class="top-item">
              <h3 class="product-main-title">${product.title}</h3>
              <p class="product-price">${product.price}</p>
            </div>
            <button class="product-view-details next-btn"
              data-collection-id='${window.giftcardcollection}'
              data-product-id="${product.id}"
              data-variant-id="${product.variantId}">
              View
            </button>
          </div>
        </div>
      </div>
    `
      )
      .join("");
  }

  const giftcardcontainer = document.querySelector(".gift-card-prod-container");
  const giftCardBackbtn = document.querySelector(".backbtn-giftcard");
  if (giftCardBackbtn) {
    giftCardBackbtn.addEventListener("click", function (e) {
      if (giftcardcontainer) {
        renderFourthStep();
        document.body.classList.remove("giftcardpopup");
        giftcardcontainer.style.display = "none";
      }
    });
  }

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("last-step-giftcard-popup")) {
      const current_profile_id = e.target.getAttribute("data-profile-id");
      currentProfileUniqueId = current_profile_id;
      const event_id = e.target.getAttribute("data-event-id");
      currentEvnetuniqueId = event_id;
      console.log("profiel id", current_profile_id);
      console.log("eventid", event_id);
      document.body.classList.add("giftcardpopup");
      if (giftcardcontainer) {
        giftcardcontainer.style.display = "block";
        const giftcardprdcontainer =
          giftcardcontainer.querySelector(".product-grid");
        giftcardprdcontainer.innerHTML = generateProductHTML(
          window.giftcardProduclist
        );
      }
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("last-step-giftwrap-popup")) {
      const product_detail_overylay = document.querySelector(
        ".product-details-overlay"
      );
      const current_profile_id = e.target.getAttribute("data-profile-id");
      const event_id = e.target.getAttribute("data-event-id");

      // Get saved wrapping choice from localStorage
      const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
      let selectedWrapping = "standard"; // default
      profiles.forEach((profile) => {
        if (profile.unique_id === current_profile_id) {
          profile.events.forEach((eventWrapper) => {
            if (
              eventWrapper.event.event_unique_id === event_id &&
              eventWrapper.event.wrapping
            ) {
              selectedWrapping = eventWrapper.event.wrapping;
            }
          });
        }
      });

      // Construct popup with correct wrapping option checked
      const giftwrap_elements = `
      <div class='product-overlay-inner'>
        <button class="giftnote-close cross-icon-product-overlay">
        <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_28_864)">
              <path d="M13.3208 20.7976C8.9108 20.7976 5.3208 17.2076 5.3208 12.7976C5.3208 8.38761 8.9108 4.79761 13.3208 4.79761C17.7308 4.79761 21.3208 8.38761 21.3208 12.7976C21.3208 17.2076 17.7308 20.7976 13.3208 20.7976ZM13.3208 2.79761C7.7908 2.79761 3.3208 7.26761 3.3208 12.7976C3.3208 18.3276 7.7908 22.7976 13.3208 22.7976C18.8508 22.7976 23.3208 18.3276 23.3208 12.7976C23.3208 7.26761 18.8508 2.79761 13.3208 2.79761ZM15.9108 8.79761L13.3208 11.3876L10.7308 8.79761L9.3208 10.2076L11.9108 12.7976L9.3208 15.3876L10.7308 16.7976L13.3208 14.2076L15.9108 16.7976L17.3208 15.3876L14.7308 12.7976L17.3208 10.2076L15.9108 8.79761Z" fill="black"></path>
            </g>
            <defs>
              <clipPath id="clip0_28_864">
                <rect width="26.2729" height="26.2729" fill="white" transform="translate(0.727051 0.797607)"></rect>
              </clipPath>
            </defs>
          </svg>
        </button>
        <div class='gift-wrapper-options'> 
          <div class='field'>
            <input id='standard-wrapping' type='radio' name='gift-wrapping' value='standard'
              ${selectedWrapping === "standard" ? "checked" : ""}
              data-profile-id="${current_profile_id}" data-event-id="${event_id}"/>
            <label for='standard-wrapping'> 
              <span class='label-header'> Standard Box - $0 </span>
              <span class='label-text'> Regular Shipping Box </span>
            </label>
          </div>
          <div class='field'>
            <input id='premium-wrapping' type='radio' name='gift-wrapping' value='premium'
              ${selectedWrapping === "premium" ? "checked" : ""}
              data-profile-id="${current_profile_id}" data-event-id="${event_id}"/>
            <label for='premium-wrapping'> 
              <span class='label-header'> Premium Wrapping - $10 </span>
              <span class='label-text'> Beautiful Wrapping & Ribbon </span>
            </label>
          </div>
        </div>
      </div>
    `;

      product_detail_overylay.innerHTML = giftwrap_elements;
      document.body.classList.add("product-overlay");
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target.name === "gift-wrapping") {
      const selectedWrapping = e.target.value; // 'standard' or 'premium'
      const profileId = e.target.getAttribute("data-profile-id");
      const eventId = e.target.getAttribute("data-event-id");

      // Get profiles from localStorage
      const profiles = JSON.parse(localStorage.getItem("profiles")) || [];

      profiles.forEach((profile) => {
        if (profile.unique_id === profileId) {
          console.log("profle id");
          profile.events.forEach((eventWrapper) => {
            console.log("events checking", eventWrapper);
            console.log("event", eventId);
            if (eventWrapper.event.event_unique_id == eventId) {
              console.log("running here", profile);
              eventWrapper.event.wrapping = selectedWrapping;

              // Initialize productSelected array if it doesn't exist
              if (!eventWrapper.productSelected) {
                eventWrapper.productSelected = [];
              }

              // Remove existing premium wrapping product if any
              eventWrapper.productSelected =
                eventWrapper.productSelected.filter(
                  (product) => product.variantId !== "50996032962836"
                );

              if (selectedWrapping == "premium") {
                eventWrapper.event.wrapping_cost = 10;

                // Add premium wrapping product line item
                const premiumWrappingProduct = {
                  image: "//cdn.shopify.com/s/files/1/0719/6934/1716/files/gift_wrap.jpg?v=1750162731", // You can add an image URL if needed
                  name: "Premium Gift Wrapping",
                  price: 10.0,
                  variantId: "50996032962836",
                  quantity: 1,
                  type: "wrapping",
                };

                eventWrapper.productSelected.push(premiumWrappingProduct);
              } else {
                eventWrapper.event.wrapping_cost = 0;
              }
            }
          });
        }
      });

      // Save it back
      localStorage.setItem("profiles", JSON.stringify(profiles));
      updateTodaysTotal(profileId, eventId);

      // Re-render the fourth step to show the updated product list
      renderFourthStep();

      console.log("Updated wrapping:", selectedWrapping);
    }
  });

  function updateTodaysTotal(profileId, eventId) {
    const allPeopleData = JSON.parse(localStorage.getItem("profiles") || "[]");
    const person = allPeopleData.find((p) => p.unique_id === profileId);
    if (!person) return;

    const eventObj = person.events.find(
      (e) => e.event.event_unique_id === eventId
    );
    if (!eventObj) return;

    // Calculate product total
    let total = 0;
    eventObj?.productSelected?.forEach((product) => {
      total += product.price * (product.quantity || 1);
    });

    // Add shipping and wrapping cost
    const shippingCost = parseFloat(eventObj.event.shipping_cost || 0);
    const wrappingCost = parseFloat(eventObj.event.wrapping_cost || 0);
    total += shippingCost;
    console.log("person checking", person);
    console.log("now event id", eventId, profileId);

    // Update the correct total UI
    const totalDiv = document.querySelector(
      `.event-total-price[data-event-id="${eventId}"][data-profile-id="${profileId}"]`
    );
    console.log("total div checking", totalDiv);
    console.log("total  div checking", total);
    if (totalDiv) {
      totalDiv.textContent = `Total: $${total.toFixed(2)}`;
    }

    const profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    const allValidEvents = [];

    profiles.forEach((person) => {
      person.events.forEach((eventObj) => {
        if (
          eventObj.event.shopfortoday &&
          Array.isArray(eventObj.productSelected) &&
          eventObj.productSelected.length > 0 &&
          eventObj.event.date
        ) {
          allValidEvents.push({
            person,
            event: eventObj,
            eventDate: new Date(eventObj.event.date),
          });
        }
      });
    });

    if (allValidEvents.length === 0) {
      // $(".last-step-error-msg").text("No valid events found.");
      $(".last-step-loader").addClass("hidden");
      return;
    }

    // Step 2: Find the nearest event
    allValidEvents.sort((a, b) => a.eventDate - b.eventDate);
    const nearest = allValidEvents[0];
    const eventObjAllToal = nearest.event;

    // Step 3: Calculate total price
    let totalall = 0;

    eventObjAllToal.productSelected.forEach((product) => {
      totalall += product.price * (product.quantity || 1);
    });

    const shippingCostAll = parseFloat(
      eventObjAllToal.event.shipping_cost || 0
    );
    const wrappingCostAll = parseFloat(
      eventObjAllToal.event.wrapping_cost || 0
    );
    totalall += shippingCostAll;

    // Step 4: Update the DOM
    const totalTextAll = `Today's Total: $${totalall.toFixed(2)}`;
    document.querySelector(".last-step-total").textContent = totalTextAll;
  }

  const form = document.querySelector(".form-box-wrapper form");
  const profileId = localStorage.getItem("currentprofile");
  const eventId = localStorage.getItem("currenevent");
  console.log("form checking ofmr", form);

  if (!form || !profileId || !eventId) return;

  form.addEventListener("submit", async function (e) {
    console.log("for  submites");
    // Step 1: Get and parse profiles
    let profiles = [];
    try {
      profiles = JSON.parse(localStorage.getItem("profiles")) || [];
    } catch (err) {
      console.error("Invalid profiles data in localStorage.");
      return;
    }

    // Step 2: Find matching profile and event
    const profile = profiles.find((p) => p.unique_id === profileId);
    if (!profile) return;

    console.log("local profole", profile);

    const eventEntry = profile.events.find(
      (ev) => ev.event.event_unique_id === eventId
    );
    if (!eventEntry) return;

    // Step 3: Fetch product from handle
    const handle = window.productRequestSettings;
    console.log("handle ofr product", handle);
    if (!handle) return;

    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();

      // Step 4: Build product object
      const newProduct = {
        image: product.images[0],
        name: product.title,
        price: product.price / 100,
        variantId: product.variants[0].id,
        quantity: 1,
        currentEvnetuniqueId: eventId,
        currentProfileUniqueId: profileId,
        type: "requestgift",
      };

      // Step 5: Add product to event and save
      eventEntry.productSelected = eventEntry.productSelected || [];
      eventEntry.productSelected.push(newProduct);
      localStorage.setItem("profiles", JSON.stringify(profiles));
      window.location.href = "/pages/gift-builder";
      showProfile(0);
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  });

});
